// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T23:48:14.301Z
// Property: Cheyenne Creek (ID: 6767906449167186)
// Collections: 33 amenities, 2 floorplans (live), 32 photos, 75 POIs, 4 reviews, 5 office hours, 11 fees (live)
// Live collections (fetched at runtime): floorplans, floorplans_full, special_offers, fees

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167186",
  "property_external_id": "785467",
  "property_zillow_url": "https://www.zillow.com/apartments/colorado-springs-co/cheyenne-creek/5YJVMj/",
  "property_apartments_url": "https://www.apartments.com/cheyenne-creek-luxury-apartment-homes-colorado-springs-co/h84hkb2/",
  "property_google_business_url": "https://www.google.com/maps/place/Cheyenne+Creek/data=!4m2!3m1!1s0x0:0xf59fa0344727f587?sa=X&ved=2ahUKEwjG6PKL8YOTAxVxHzQIHfu7LUUQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47593918060",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cheyenne-creek",
  "property_name": "Cheyenne Creek",
  "property_website_url": "https://www.cheyennecreekapartments.com",
  "property_domain": "https://www.cheyennecreekapartments.com",
  "property_address": "145 W Cheyenne Rd",
  "property_full_address": "145 W Cheyenne Rd, Colorado Springs, CO 80906",
  "property_address_1": "145 W Cheyenne Rd",
  "property_address_2": null,
  "property_address_city": "Colorado Springs",
  "property_address_state": "CO",
  "property_address_zip_full": "80906",
  "property_address_zip": "80906",
  "property_address_country": "US",
  "property_address_county": "El Paso County",
  "property_neighborhood_address": "Broadmoor",
  "property_address_latitude": "38.8051648",
  "property_address_longitude": "-104.8304078",
  "property_email": "cheyennecreek@weidner.com",
  "property_phone": "7193504219",
  "property_call_tracking_phone": "719-426-3536",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Cheyenne Creek in Colorado Springs, where modern comforts meet natural beauty. Our spacious two-bedroom apartments feature upgraded homes with granite countertops and stainless steel appliances. Enjoy 24-hour access to a vibrant community with a fitness center, pool, and serene walking trails. Your perfect sanctuary awaits!",
  "property_long_description": "Welcome to Cheyenne Creek, your ideal apartment community nestled in the heart of beautiful Colorado Springs, CO! Experience a perfect blend of comfort and luxury with our thoughtfully designed two-bedroom floor plans, perfect for families or roommates looking to settle down in a vibrant neighborhood. \n\nAt Cheyenne Creek, we prioritize your convenience and peace of mind with 24-hour access, controlled entry, and an on-site property manager ready to assist you. Indulge in a range of exceptional amenities, including a state-of-the-art fitness center, inviting lounge areas, and a relaxing pool and spa. Enjoy outdoor living in our beautifully landscaped courtyard and picnic areas with grills, perfect for gatherings with friends and family.\n\nOur upgraded homes feature luxurious finishes, such as granite countertops, stainless steel appliances, and spacious walk-in closets. Each apartment includes central air conditioning and heating, high-speed internet access, and energy-efficient appliances to cater to your modern lifestyle. You’ll find easy access to walking and biking trails right outside your door, promoting an active and healthy lifestyle.\n\nCheyenne Creek offers a smoke-free environment, ensuring your home remains a serene retreat. With a business center and covered parking available, our community understands the importance of both work and leisure. \n\nDiscover your new home today at Cheyenne Creek—browse our availability or schedule a tour to experience all that our community has to offer! Your perfect apartment awaits in the stunning landscapes of Colorado Springs.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-368c-76cf-bded-4960c8fc2483.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with fireplace, sofa, armchair, coffee tables, and large sliding glass doors.",
    "public_id": "019d021e-368c-76cf-bded-4960c8fc2483",
    "storage_key": "property/6767906449167186/019d021e-368c-76cf-bded-4960c8fc2483.webp",
    "width": 800,
    "height": 533
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "108",
  "property_year_built": "1985",
  "property_year_renovated": null,
  "property_walk_score": "68",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.29629629629629",
  "property_admin_fee": "200",
  "property_application_fee": "25",
  "property_fees_deposit_info": "Security deposit: $500 (refundable)",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "70",
  "property_pet_restrictions": "Breed restrictions apply",
  "property_pet_policy_description": "Up to 2 pets per home are welcome.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://cheyennecreekapartments.securecafe.com/onlineleasing/cheyenne-creek/floorplans.aspx",
  "property_resident_portal_url": "https://cheyennecreekapartments.securecafenet.com/residentservices/cheyenne-creek/userlogin",
  "property_apply_now_url": "https://cheyennecreekapartments.securecafe.com/onlineleasing/cheyenne-creek/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d1a-8eac-7759-ae8a-ec1db2690c8f.webp",
  "property_primary_logo_media": {
    "alt_text": "Cheyenne Creek Luxury Apartment Homes logo.",
    "public_id": "01a10d1a-8eac-7759-ae8a-ec1db2690c8f",
    "storage_key": "property/6767906449167186/01a10d1a-8eac-7759-ae8a-ec1db2690c8f.webp",
    "width": 89,
    "height": 75
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d1a-cf85-711a-89ad-700d2cb7f8f6.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Management company logo",
    "public_id": "01a10d1a-cf85-711a-89ad-700d2cb7f8f6",
    "storage_key": "property/6767906449167186/01a10d1a-cf85-711a-89ad-700d2cb7f8f6.webp",
    "width": 89,
    "height": 75
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d1a-c504-7715-81c0-b1daab50b53b.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Management Company Logo",
    "public_id": "01a10d1a-c504-7715-81c0-b1daab50b53b",
    "storage_key": "property/6767906449167186/01a10d1a-c504-7715-81c0-b1daab50b53b.webp",
    "width": 89,
    "height": 75
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#583524",
  "property_secondary_color": "#E6EDCB",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#A99757",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 2",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1050",
  "property_sqft_min": "900",
  "property_sqft_max": "1050",
  "property_price_range": "1665 - 2745",
  "property_price_min": "1660",
  "property_price_max": "2470",
  "property_available_units": 4,
  "property_facebook_url": "https://www.facebook.com/CheyenneCreekApartments",
  "property_instagram_url": "https://www.instagram.com/p/DXdAyMMky3v/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJFbM37MZEE4cRh_UnRzSgn_U",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cheyenne Creek",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection Here",
  "property_home_amenities_blurb": "Welcome to Cheyenne Creek in Colorado Springs, where modern living meets serene landscapes. Choose from our stylish two-bedroom apartment homes featuring granite countertops, stainless steel appliances, and spacious walk-in closets. Enjoy a range of amenities including a fitness center, tranquil pool, and charming picnic area—your perfect retreat awaits!",
  "property_home_floorplans_blurb": "Welcome to Cheyenne Creek, where Colorado Springs meets modern living. Nestled in scenic surroundings, our diverse floor plans offer the perfect blend of comfort and style to suit your lifestyle. Dive into our selection and find the ideal apartment home that awaits your personal touch.",
  "property_home_gallery_blurb": "At Cheyenne Creek in Colorado Springs, your ideal two-bedroom sanctuary awaits. Enjoy 24-hour access to an array of upscale amenities, from a sparkling pool to scenic walking trails. With upgraded homes featuring granite countertops and stainless steel appliances, picture vibrant living in a community designed for your comfort and convenience.",
  "property_home_neighborhood_blurb": "At Cheyenne Creek in vibrant Colorado Springs, your two-bedroom apartment is a gateway to adventure. Discover nature's finest at Garden of the Gods and Cheyenne Mountain State Park, or immerse yourself in local culture at the U.S. Olympic & Paralympic Museum. Explore the perfect blend of comfort and community!",
  "property_home_reviews_blurb": "At Cheyenne Creek in scenic Colorado Springs, residents rave about the “spectacular views and friendly community.” Experience a lifestyle where nature meets comfort, and every moment feels special. Curious about what makes us unique? See what our residents have to say about living at our vibrant community!",
  "property_neighborhood_blurb": "At Cheyenne Creek in Colorado Springs, vibrant living meets endless adventure. Immerse yourself in nature with easy access to Cheyenne Mountain State Park and the stunning Garden of the Gods. Plus, enjoy local culture at the U.S. Olympic & Paralympic Museum or unwind at the nearby fitness centers. Experience life reimagined!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cheyenne Creek in Colorado Springs, luxury meets comfort. Enjoy two-bedroom apartments adorned with granite countertops and stainless steel appliances. Unwind in our resort-style pool, or stay active in the fitness center. With amenities like a resident lounge, picnic area, and nearby walking trails, every day is a new adventure.",
  "property_applynow_blurb": "Nestled in the heart of Colorado Springs, Cheyenne Creek offers luxurious two-bedroom floor plans designed for modern living. With top-tier amenities like a fitness center, sparkling pool, and charming picnic area, your dream apartment awaits. Experience upgraded homes with granite countertops and stainless steel appliances—your new lifestyle starts now!",
  "property_contactus_blurb": "At Cheyenne Creek in beautiful Colorado Springs, CO, our spacious two-bedroom apartments are designed for comfort and style. Enjoy breathtaking views and modern amenities. Have questions about our floor plans or availability? Reach out to our friendly leasing team today to discover your new home!",
  "property_faqs_blurb": "At Cheyenne Creek in beautiful Colorado Springs, CO, our spacious two-bedroom floor plans perfectly blend comfort and style. Have questions about our vibrant community? Our FAQs page is here to guide you! Delve into the details and discover everything you need to know about life at Cheyenne Creek.",
  "property_floorplans_blurb": "At Cheyenne Creek in Colorado Springs, unique living spaces await in our thoughtfully designed two-bedroom apartments. Embrace the perfect blend of comfort and style as you envision your life in this vibrant community. Browse our available options and find the ideal floor plan that aligns with your lifestyle today!",
  "property_gallery_blurb": "At Cheyenne Creek in beautiful Colorado Springs, each two-bedroom apartment blends modern luxury with comfort. Imagine unwinding in your upgraded home featuring granite countertops and stainless steel appliances. Enjoy exclusive amenities like a sparkling pool, fitness center, and serene walking trails. Picture yourself living here—your oasis awaits!",
  "property_interactivemap_blurb": "Welcome to Cheyenne Creek, where modern living meets the beauty of Colorado Springs. Enjoy spacious two-bedroom apartments with upgraded interiors, stunning views, and a host of amenities including a fitness center, pool, and serene walking trails. Unleash your lifestyle with our interactive community map and find your perfect home today!",
  "property_pets_blurb": "At Cheyenne Creek in Colorado Springs, your furry friends are part of the family! With a pet-friendly policy accommodating up to two dogs or cats, you can enjoy a vibrant community that welcomes your beloved companions while embracing a serene lifestyle against stunning mountain views. Restrictions apply—let your pets thrive!",
  "property_referafriend_blurb": "At Cheyenne Creek in Colorado Springs, CO, our spacious two-bedroom apartments offer the perfect blend of comfort and style. Embrace a vibrant community atmosphere where great friends become great neighbors. Refer a friend today and share the joy of living in a place that feels like home!",
  "property_residentaccess_blurb": "At Cheyenne Creek in Colorado Springs, CO, our spacious two-bedroom floor plans offer a perfect blend of comfort and style. Residents can easily manage their living experience through our dedicated portal—pay rent, schedule maintenance, and connect with the community. Access your resident portal today and elevate your living experience!",
  "property_reviews_blurb": "At Cheyenne Creek in Colorado Springs, our residents rave about the vibrant community spirit and stunning views: “Living here feels like a true escape!” See what our residents have to say about their experience and why Cheyenne Creek is the perfect place to call home!",
  "property_created_at": "1771537640112",
  "property_scheduletour_blurb": "Nestled in the heart of Colorado Springs, Cheyenne Creek offers inviting two-bedroom floor plans designed for comfort and style. Experience our vibrant community, where stunning views blend seamlessly with modern living. Schedule a tour today and hear firsthand from our residents about their exceptional lifestyle at Cheyenne Creek!",
  "property_thankyou_blurb": "Thank you for reaching out to Cheyenne Creek in beautiful Colorado Springs! We appreciate your interest in our inviting two-bedroom floor plans. Stay tuned, as our team will be in touch shortly to help you find your perfect home in our vibrant community!",
  "property_virtualtours_blurb": "At Cheyenne Creek in vibrant Colorado Springs, CO, our spacious two-bedroom floor plans offer a blend of comfort and style. Immerse yourself in the beautiful surroundings and modern amenities—your perfect home awaits. Ready to envision your new lifestyle? Take a virtual tour of our community and apartments for rent today!",
  "property_copyright": "2026 All Rights Reserved. Cheyenne Creek",
  "property_seo_title_home": "Cheyenne Creek apartments - comfy living in Colorado Springs, CO",
  "property_seo_description_home": "Discover relaxed, pet-friendly living at Cheyenne Creek apartments. All-in pricing and on-site comforts await in Colorado Springs, CO.",
  "property_seo_title_floorplans": "Two bedroom floor plans - Cheyenne Creek - Colorado Springs",
  "property_seo_description_floorplans": "Discover spacious two-bedroom floor plans at Cheyenne Creek with walk-in closets, in-unit laundry, and storage in Colorado Springs, CO.",
  "property_seo_title_amenities": "Amenities at Cheyenne Creek - Colorado Springs, CO",
  "property_seo_description_amenities": "Enjoy an indoor pool, fitness center, fireplace, granite counters, and in-unit laundry at Cheyenne Creek in Colorado Springs, CO.",
  "property_seo_title_gallery": "Photo gallery - Cheyenne Creek - Colorado Springs, CO",
  "property_seo_description_gallery": "See Cheyenne Creek's photo gallery featuring vibrant apartments, an indoor pool, and community spaces in Colorado Springs, CO.",
  "property_seo_title_virtualtours": "Cheyenne Creek virtual tour - Colorado Springs, CO",
  "property_seo_description_virtualtours": "Experience Cheyenne Creek in Colorado Springs, CO from anywhere. Tour virtually to picture apartment life and community living.",
  "property_seo_title_interactivemap": "Interactive Map | Cheyenne Creek Apartments",
  "property_seo_description_interactivemap": "Find your dream home at Cheyenne Creek in Colorado Springs! Use our interactive map to explore spacious two-bedroom layouts and fantastic amenities today.",
  "property_seo_title_neighborhood": "Ivy Wild neighborhood - Cheyenne Creek - Colorado Springs",
  "property_seo_description_neighborhood": "Enjoy vibrant Ivy Wild living at Cheyenne Creek near Bear Creek Park, Creek Walk, downtown, and I-25 in Colorado Springs, CO.",
  "property_seo_title_contact": "Contact Cheyenne Creek apartments - Colorado Springs, CO",
  "property_seo_description_contact": "Connect with Cheyenne Creek apartments in Colorado Springs, CO. Our friendly leasing team is ready to help you explore your options.",
  "property_seo_title_faqs": "FAQs | Apartments in Colorado Springs, CO",
  "property_seo_description_faqs": "Discover essential info about Cheyenne Creek in Colorado Springs. Our FAQs cover amenities, floor plans, and everything for your future home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Colorado Springs, CO",
  "property_seo_description_reviews": "Join the Cheyenne Creek community in Colorado Springs! Read what residents love about our modern amenities, spacious floor plans, and vibrant lifestyle.",
  "property_seo_title_applynow": "Apply Now | Apartments in Colorado Springs, CO",
  "property_seo_description_applynow": "Discover modern living at Cheyenne Creek, Colorado Springs! Enjoy upgraded homes, a fitness center, pool, and serene outdoor spaces. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Cheyenne Creek",
  "property_seo_description_residentaccess": "Unlock your Cheyenne Creek experience! Log in to manage your rent, schedule maintenance, and connect with your community in beautiful Colorado Springs, CO.",
  "property_seo_title_referafriend": "Refer A Friend | Cheyenne Creek",
  "property_seo_description_referafriend": "Refer a friend to Cheyenne Creek in Colorado Springs! Great friends make the best neighbors—join our vibrant community and enjoy all we offer together!",
  "property_seo_title_scheduletour": "Schedule a tour - Cheyenne Creek - Colorado Springs, CO",
  "property_seo_description_scheduletour": "Visit Cheyenne Creek in Colorado Springs, CO. Schedule a tour to explore comfortable two-bedroom apartments and inviting amenities today.",
  "property_seo_title_privacy": "Privacy Policy | Cheyenne Creek",
  "property_seo_description_privacy": "At Cheyenne Creek in Colorado Springs, your privacy matters. Learn how we safeguard your data and enjoy peace of mind. Read our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Cheyenne Creek",
  "property_seo_description_accessibility": "At Cheyenne Creek, we prioritize accessibility and inclusivity for all. Join our community where everyone can thrive! Learn more about our commitment.",
  "property_seo_title_sitemap": "Sitemap | Cheyenne Creek",
  "property_seo_description_sitemap": "Unveil the charm of Cheyenne Creek in Colorado Springs. Navigate our sitemap for a seamless journey through our community and find your perfect home!",
  "property_seo_title_thankyou": "Thank You | Cheyenne Creek",
  "property_seo_description_thankyou": "Thank you for reaching out! Your Cheyenne Creek info is in good hands—our team will connect with you soon to help you find your perfect Colorado Springs home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Colorado Springs, CO",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764152",
  "amenities": [
    {
      "id": "ec_a5f4574d94b4849a5eba110c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111728",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-64e0-702a-8572-97ab0b3525cc.webp",
      "amenity_image_media": {
        "alt_text": "Indoor swimming pool and jacuzzi with large windows overlooking greenery.",
        "public_id": "019d021e-64e0-702a-8572-97ab0b3525cc",
        "storage_key": "property/6767906449167186/019d021e-64e0-702a-8572-97ab0b3525cc.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Swimming Pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19e9fafd81676e6e49815705",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111703",
      "title": "24 Hour Availability",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09db0ca1d94df82c10d273d0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111704",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_af44d14048dc875aa2ab6ff9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111705",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4a26638ee3df2f4cd430d0ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111706",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c9ecdfe25a439dd1d732749",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111714",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df9a6cf2dd074d63dc74e04b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111720",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-87d7-755f-8580-dc4d09ee8641.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor patio seating area with tables and chairs overlooking a courtyard with trees and apartment buildings.",
        "public_id": "019d021e-87d7-755f-8580-dc4d09ee8641",
        "storage_key": "property/6767906449167186/019d021e-87d7-755f-8580-dc4d09ee8641.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Cheyenne Creek Outdoor Lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6552a114365b9c7edb019221",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111721",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4cf392122df7621b2152dbcc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111725",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d9a34-e20f-7318-9523-226d9826a023.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills, ellipticals, stationary bikes, and free weights.",
        "public_id": "019d9a34-e20f-7318-9523-226d9826a023",
        "storage_key": "property/6767906449167186/019d9a34-e20f-7318-9523-226d9826a023.webp",
        "width": 1023,
        "height": 683
      },
      "amenity_image_alt_text": "Cheyenne Creek Resident Lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d087b18f6bb23103b0d6654b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111726",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1cc0a184e4b7f156a198acdf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111729",
      "title": "Spa/Hot Tub",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d73649e08c5b15a99502d0ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111748",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b48c40cddb386a3584cbf4df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111744",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed347522d4c60ffb910f29ed",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111733",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c78757c53fba4a18f45cb592",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111736",
      "title": "Energy Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_029ade0760666c893ab5a029",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111746",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a248550728797de0905f9cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111750",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-9014-718b-97a9-b97d1059529a.webp",
      "amenity_image_media": {
        "alt_text": "Covered balcony with a table, chairs, and decorative screen.",
        "public_id": "019d021e-9014-718b-97a9-b97d1059529a",
        "storage_key": "property/6767906449167186/019d021e-9014-718b-97a9-b97d1059529a.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Cheyenne Creek Large Balcony",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_776eceb19c07d6246d0f4b4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111765",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d9a34-e10f-726b-b37c-65c6e93d900c.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer in laundry room",
        "public_id": "019d9a34-e10f-726b-b37c-65c6e93d900c",
        "storage_key": "property/6767906449167186/019d9a34-e10f-726b-b37c-65c6e93d900c.webp",
        "width": 1023,
        "height": 683
      },
      "amenity_image_alt_text": "Cheyenne Creek Washer Dryer",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbf0385a7517c57da54e4b69",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111783",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46085a18814f568026d943a8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111738",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-e169-770a-8dfa-72c7cbbdc71c.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, black appliances, and granite countertops.",
        "public_id": "019d021e-e169-770a-8dfa-72c7cbbdc71c",
        "storage_key": "property/6767906449167186/019d021e-e169-770a-8dfa-72c7cbbdc71c.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Cheyenne Creek Kitchen Apartments in Colorado Springs, CO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a331f0c69de275eecd6a853",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111743",
      "title": "Central AC and Heating per apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1311bbf9f2b00f05beec886",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111716",
      "title": "Coffee Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_366c1ea55720b9f8b6d00621",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111718",
      "title": "Disposal Chutes",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5372e5fb73abd5f99be54a63",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111723",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee3f664187f9d64de7ede634",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111768",
      "title": "Built-In Bookshelves",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62f1f53541e45c3e3fb64c79",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111770",
      "title": "Dining Room",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8204ee942dbc59406a2ce6ff",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111775",
      "title": "Intercom/Call Box",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a02306b54092e913960aa697",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111776",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1794317c215b26f559a174d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111731",
      "title": "Cardio Machines",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db11503f31bdfa449da6d77a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "121234652",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-e1f6-77ea-939e-a6dd5cd0b561.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking spaces with cars parked underneath.",
        "public_id": "019d021e-e1f6-77ea-939e-a6dd5cd0b561",
        "storage_key": "property/6767906449167186/019d021e-e1f6-77ea-939e-a6dd5cd0b561.webp",
        "width": 2560,
        "height": 1707
      },
      "amenity_image_alt_text": "Cheyenne Creek Parking Apartments in Colorado Springs, CO",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_887339f1b9fb153cd3bcf3de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "124799845",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c505fc4384f26b4e03b6c7d5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86111780",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5569a2be1f8047d38846144f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "86232216",
      "title": "Resident Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-723a-75ca-976c-286a00a67b31.webp",
      "amenity_image_media": {
        "alt_text": "Lobby seating area with fireplace and bar.",
        "public_id": "019d021e-723a-75ca-976c-286a00a67b31",
        "storage_key": "property/6767906449167186/019d021e-723a-75ca-976c-286a00a67b31.webp",
        "width": 1920,
        "height": 1280
      },
      "amenity_image_alt_text": "Cheyenne Creek Residents Lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_7558a2b19a76c6e0521ddcd7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-368c-76cf-bded-4960c8fc2483.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, sofa, armchair, coffee tables, and large sliding glass doors.",
        "public_id": "019d021e-368c-76cf-bded-4960c8fc2483",
        "storage_key": "property/6767906449167186/019d021e-368c-76cf-bded-4960c8fc2483.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable seating, and access to an outdoor patio area.",
      "link": "false",
      "alt_text": "A bright modern living room here at Cheyenne Creek Luxury featuring a cozy seating area with a sofa, accent chair, and coffee table arranged on soft carpet, a fireplace along the wall, and large sliding glass doors opening to a private patio, with neutral décor, layered lighting, and natural light creating a warm and inviting atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(1).jpg"
    },
    {
      "id": "ec_1c890dadbe2aa28aeeef944a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-3724-777b-8283-8f9dc69ec739.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, armchair, coffee table, and large window.",
        "public_id": "019d021e-3724-777b-8283-8f9dc69ec739",
        "storage_key": "property/6767906449167186/019d021e-3724-777b-8283-8f9dc69ec739.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A tastefully decorated living room featuring a comfortable sofa, an accent armchair, a unique coffee table, and access to a patio area through a large sliding glass door.",
      "link": "false",
      "alt_text": "A cozy inviting living room here at Cheyenne Creek Luxury featuring a comfortable sofa with accent pillows, a patterned armchair, and sculptural wooden side tables arranged on plush carpet, with a fireplace, abundant greenery, and large sliding glass doors that open to a private patio, creating a warm, relaxed, and welcoming atmosphere filled with natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(2).jpg"
    },
    {
      "id": "ec_72dd6c5cff97e87f4d169b7f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-5185-7496-898d-d7c2a7a9860f.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, two chairs, and a coffee table.",
        "public_id": "019d021e-5185-7496-898d-d7c2a7a9860f",
        "storage_key": "property/6767906449167186/019d021e-5185-7496-898d-d7c2a7a9860f.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "Comfortable bedroom featuring a cozy bed, seating area with chairs and a coffee table, and large windows.",
      "link": "false",
      "alt_text": "A bright bedroom sitting area here at Cheyenne Creek Luxury showcasing two upholstered accent chairs positioned near large corner windows with white blinds and sheer curtains, a round wooden coffee table styled with simple decor, plush carpet flooring, and a coordinating side table with a modern lamp that creates a calm, inviting retreat within the bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(10).jpg"
    },
    {
      "id": "ec_f326651ae1daf17aaa2227aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-4423-751c-a7f9-e8b189d09a84.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, sitting area with two armchairs, and large windows.",
        "public_id": "019d021e-4423-751c-a7f9-e8b189d09a84",
        "storage_key": "property/6767906449167186/019d021e-4423-751c-a7f9-e8b189d09a84.webp",
        "width": 722,
        "height": 475
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, a cozy sitting area with upholstered armchairs, and abundant natural light from large windows.",
      "link": "false",
      "alt_text": "A cozy bedroom here at Cheyenne Creek Luxury showcasing a comfortable bed with layered bedding, matching nightstands with lamps, plush carpeting, and soft neutral walls, complemented by a sitting area with upholstered chairs, natural light from a large window with curtains, and tasteful wall art creating a relaxing retreat.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(6).jpg"
    },
    {
      "id": "ec_c59e07c4ace3153d708b9605",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-44e9-701e-88da-f45048464ea6.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-sized bed, nightstands, and a comfortable chair.",
        "public_id": "019d021e-44e9-701e-88da-f45048464ea6",
        "storage_key": "property/6767906449167186/019d021e-44e9-701e-88da-f45048464ea6.webp",
        "width": 1023,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed bedroom, featuring a plush queen-sized bed, elegant nightstands, and a cozy armchair perfect for reading.",
      "link": "false",
      "alt_text": "A warm bedroom here at Cheyenne Creek Luxury featuring a spacious bed with textured blue bedding, matching wooden nightstands with table lamps, soft carpet flooring, and neutral walls accented by decorative wall art, with a cozy sitting area, potted greenery, and natural light filtering through a large window with sheer curtains.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(7).jpg"
    },
    {
      "id": "ec_3535f7383e751591e2bb6469",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-4762-72bb-8e2e-f144142d4fbf.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, and a view into a bathroom.",
        "public_id": "019d021e-4762-72bb-8e2e-f144142d4fbf",
        "storage_key": "property/6767906449167186/019d021e-4762-72bb-8e2e-f144142d4fbf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully decorated bedroom featuring a plush queen-size bed, elegant nightstands with lamps, and a glimpse into an adjoining bathroom.",
      "link": "false",
      "alt_text": "A serene bedroom here at Cheyenne Creek Luxury featuring a centered bed with layered blue and brown bedding, matching wooden nightstands with table lamps, soft carpet flooring, and neutral walls accented by decorative wall art, with an open view into an adjoining bathroom and a small accent table in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(8).jpg"
    },
    {
      "id": "ec_881dd676f699348e025b64bb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-5156-76aa-b75b-3a333d7e9770.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstands, and a view into the bathroom.",
        "public_id": "019d021e-5156-76aa-b75b-3a333d7e9770",
        "storage_key": "property/6767906449167186/019d021e-5156-76aa-b75b-3a333d7e9770.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "A well-appointed bedroom featuring a comfortable bed, elegant nightstands with lamps, and convenient access to the bathroom. ",
      "link": "false",
      "alt_text": "A bright bedroom here at Cheyenne Creek Luxury featuring a centered bed with neutral bedding and accent pillows, matching wooden nightstands with modern table lamps, soft carpet flooring, and light walls with abstract artwork above the headboard, plus an open doorway leading to an adjoining bathroom that adds depth and natural flow to the space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(9).jpg"
    },
    {
      "id": "ec_019895058dee4cbcd3a3266a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-3724-777b-8283-87a4cba092aa.webp",
      "image_media": {
        "alt_text": "Kitchen with beige cabinets, a white refrigerator, a toaster, and a double sink.",
        "public_id": "019d021e-3724-777b-8283-87a4cba092aa",
        "storage_key": "property/6767906449167186/019d021e-3724-777b-8283-87a4cba092aa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional kitchen featuring beige cabinetry, a large refrigerator, a toaster, and a spacious double sink, perfect for meal preparation.",
      "link": "false",
      "alt_text": "A bright functional kitchen here at Cheyenne Creek Luxury featuring light wood cabinetry, ample counter space, a white appliance suite, and a stainless sink, accented by decorative shelving, warm lighting, and simple countertop decor that creates a clean, welcoming space ideal for everyday cooking and entertaining.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(3).jpg"
    },
    {
      "id": "ec_20ac87ee9bc0b9ee2fa49a47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-36df-77e5-bce7-8d042c86d45d.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, white cabinets, and black refrigerator.",
        "public_id": "019d021e-36df-77e5-bce7-8d042c86d45d",
        "storage_key": "property/6767906449167186/019d021e-36df-77e5-bce7-8d042c86d45d.webp",
        "width": 800,
        "height": 533
      },
      "title": "Apartment",
      "description": "Explore this spacious kitchen featuring granite countertops, ample cabinet space, and modern appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A bright contemporary kitchen here at Cheyenne Creek Luxury showcasing white cabinetry, granite-style countertops, a double-basin sink, and a full appliance setup, complemented by pendant lighting, decorative plants, and an open pass-through design that enhances functionality, natural light, and everyday convenience for residents.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(4).jpg"
    },
    {
      "id": "ec_58fa1e3089c264511c6b3312",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-432f-7771-8609-fbb82462e893.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and a toaster.",
        "public_id": "019d021e-432f-7771-8609-fbb82462e893",
        "storage_key": "property/6767906449167186/019d021e-432f-7771-8609-fbb82462e893.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A bright and clean kitchen featuring light wood cabinetry, a white refrigerator, oven, and dishwasher. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "A warm, functional kitchen here at Cheyenne Creek Luxury featuring light wood cabinetry, spacious countertops, a full appliance layout, and open shelving accents, complemented by neutral finishes and thoughtful details that create an inviting space designed for everyday cooking, storage, and comfortable apartment living.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(5).jpg"
    },
    {
      "id": "ec_3620a5594a3358d778688c2a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-549c-72a0-8ba8-2dd4a0ab0389.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and shower.",
        "public_id": "019d021e-549c-72a0-8ba8-2dd4a0ab0389",
        "storage_key": "property/6767906449167186/019d021e-549c-72a0-8ba8-2dd4a0ab0389.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a sink, a toilet, and a glass-enclosed shower. The space is well-lit and includes decorative accents.",
      "link": "false",
      "alt_text": "A clean, well-lit bathroom here at Cheyenne Creek Luxury featuring a single-sink vanity with light wood cabinetry, a wide mirror with overhead lighting, neutral countertops with decorative accents, and a towel ring beside the vanity, with an adjacent shower area visible through an open doorway creating a functional, inviting bathroom layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(11).jpg"
    },
    {
      "id": "ec_7c3f81ce84d809bd3581b68a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-562a-70af-90b4-00b3685b6f05.webp",
      "image_media": {
        "alt_text": "Bathroom with brown curtains, toilet, sink, and mirror",
        "public_id": "019d021e-562a-70af-90b4-00b3685b6f05",
        "storage_key": "property/6767906449167186/019d021e-562a-70af-90b4-00b3685b6f05.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and well-maintained bathroom featuring a toilet, sink, and stylish brown curtains.",
      "link": "false",
      "alt_text": "A warm, inviting bathroom here at Cheyenne Creek Luxury featuring a light wood vanity with a single sink and neutral countertop, a large wall mirror with overhead lighting, a white toilet with coordinating towel bar, and a shower area with a rich brown fabric shower curtain accented by subtle patterns, creating a cohesive and comfortable bathroom space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(12).jpg"
    },
    {
      "id": "ec_7ced1b33bc510946096d3ada",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-5dcf-74ce-990b-e3c35c9b7c9c.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool and jacuzzi area with large windows overlooking trees.",
        "public_id": "019d021e-5dcf-74ce-990b-e3c35c9b7c9c",
        "storage_key": "property/6767906449167186/019d021e-5dcf-74ce-990b-e3c35c9b7c9c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our indoor heated swimming pool and relaxing jacuzzi, perfect for unwinding year-round. Large windows provide a serene view of the surrounding nature.",
      "link": "false",
      "alt_text": "A serene indoor pool here at Cheyenne Creek Luxury featuring a curved pool edge with stone detailing, clear reflective water, tall windows that bring in abundant natural light and views of surrounding trees, stone accent walls, metal handrails for easy entry, and a calm, spa-like atmosphere designed for year-round relaxation.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(13).jpg"
    },
    {
      "id": "ec_3c620e1e73f802c83cfaeada",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-64e0-702a-8572-97ab0b3525cc.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool and jacuzzi with large windows overlooking greenery.",
        "public_id": "019d021e-64e0-702a-8572-97ab0b3525cc",
        "storage_key": "property/6767906449167186/019d021e-64e0-702a-8572-97ab0b3525cc.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our indoor swimming pool or relax in the bubbling jacuzzi, surrounded by lush green views through large windows.",
      "link": "false",
      "alt_text": "A bright indoor pool here at Cheyenne Creek Luxury featuring a connected spa with bubbling water, stone-accent pool deck, metal handrails for easy entry, large windows that fill the space with natural light, and peaceful views of surrounding trees creating a relaxing, resort-style atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(14).jpg"
    },
    {
      "id": "ec_dfb68b1636b2a30422dfa1b8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-64df-7427-97a5-b239de04db00.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, stationary bikes, and free weights.",
        "public_id": "019d021e-64df-7427-97a5-b239de04db00",
        "storage_key": "property/6767906449167186/019d021e-64df-7427-97a5-b239de04db00.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring state-of-the-art cardio machines and free weights for a complete workout experience.",
      "link": "false",
      "alt_text": "A spacious fitness center here at Cheyenne Creek Luxury showcasing treadmills, ellipticals, and strength training equipment, rubber flooring for workouts, tall windows with wooded views that bring in natural light, warm pendant lighting overhead, and an open layout designed for comfortable and energizing exercise sessions.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(15).jpg"
    },
    {
      "id": "ec_f0518307d42c6c23e0d0e708",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-6507-73ad-8e22-bf330f12b882.webp",
      "image_media": {
        "alt_text": "Treadmills, an elliptical, a stationary bike, and a weight machine in a well-lit gym with large windows.",
        "public_id": "019d021e-6507-73ad-8e22-bf330f12b882",
        "storage_key": "property/6767906449167186/019d021e-6507-73ad-8e22-bf330f12b882.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our spacious fitness center features a variety of cardio machines and weight training equipment to help you stay active and healthy.",
      "link": "false",
      "alt_text": "A bright fitness center here at Cheyenne Creek Luxury featuring treadmills, ellipticals, and a multi-station strength machine, soft carpeted flooring, pendant lighting, tall interior windows overlooking the clubhouse, and an open staircase that adds a spacious, airy feel for comfortable daily workouts.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(16).jpg"
    },
    {
      "id": "ec_8d048fc575cc5481482861fe",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-723a-75ca-976c-286a00a67b31.webp",
      "image_media": {
        "alt_text": "Lobby seating area with fireplace and bar.",
        "public_id": "019d021e-723a-75ca-976c-286a00a67b31",
        "storage_key": "property/6767906449167186/019d021e-723a-75ca-976c-286a00a67b31.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Gather in our stylish community lobby, featuring a cozy fireplace, comfortable seating, and a convenient bar area, perfect for socializing.",
      "link": "false",
      "alt_text": "A warm clubhouse lounge here at Cheyenne Creek Luxury featuring a stone fireplace with a wood mantel, comfortable black leather seating, a high-top dining table with chairs, and a built-in bar area, complemented by tall windows, pendant lighting, and tiled floors that create an inviting space for relaxing or gathering.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(17).jpg"
    },
    {
      "id": "ec_cacafcb0b036015d5aa28507",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-7854-744a-83df-845dc4a9fe2b.webp",
      "image_media": {
        "alt_text": "Lobby with elevator, seating area, and wood accents.",
        "public_id": "019d021e-7854-744a-83df-845dc4a9fe2b",
        "storage_key": "property/6767906449167186/019d021e-7854-744a-83df-845dc4a9fe2b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "The elegant lobby features a comfortable seating area with leather chairs, an elevator, and rich wood accents, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "A welcoming lobby seating area here at Cheyenne Creek Luxury featuring coffered wood-accent ceilings, slate-style flooring, black leather armchairs arranged around a round coffee table, soft wall sconces, pendant lighting, and an elevator and hallway access that create a polished and comfortable shared space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(18).jpg"
    },
    {
      "id": "ec_1a67fe2a395788094b861728",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-78da-71c3-bd54-71f3e540d0e6.webp",
      "image_media": {
        "alt_text": "Lobby seating area with fireplace and large windows.",
        "public_id": "019d021e-78da-71c3-bd54-71f3e540d0e6",
        "storage_key": "property/6767906449167186/019d021e-78da-71c3-bd54-71f3e540d0e6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our comfortable lobby, featuring a cozy fireplace and ample natural light from large windows. Enjoy the communal space.",
      "link": "false",
      "alt_text": "A warm clubhouse lounge here at Cheyenne Creek Luxury featuring a stone fireplace with wood mantel, black leather lounge chairs, slate-style flooring, dining tables, tall windows that frame wooded views, and soft pendant lighting that creates an inviting space for relaxing or gathering.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(19).jpg"
    },
    {
      "id": "ec_e160799489f4ed21d6bfac2a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-7eda-7206-8070-ba827cd67dde.webp",
      "image_media": {
        "alt_text": "Dining area with a round mirror and a small table with snacks.",
        "public_id": "019d021e-7eda-7206-8070-ba827cd67dde",
        "storage_key": "property/6767906449167186/019d021e-7eda-7206-8070-ba827cd67dde.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy dining area featuring a round decorative mirror and a wooden table with a bowl of snacks, perfect for a quick bite before heading out.",
      "link": "false",
      "alt_text": "A cozy open living and dining area here at Cheyenne Creek Luxury featuring a round wooden dining table with woven seating, soft carpeted floors, warm accent walls with decorative mirrors, a potted indoor tree, and an inviting living space that opens to a private patio with natural light and wooded views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(20).jpg"
    },
    {
      "id": "ec_a2db3d18ad36843aa8bbc13f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-8327-749c-b403-20a506344fe3.webp",
      "image_media": {
        "alt_text": "Executive desk and chairs in an office space with large windows.",
        "public_id": "019d021e-8327-749c-b403-20a506344fe3",
        "storage_key": "property/6767906449167186/019d021e-8327-749c-b403-20a506344fe3.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Work from home in style with this executive office setup. Features a large wooden desk, comfortable chairs, and ample natural light.",
      "link": "false",
      "alt_text": "A bright business center here at Cheyenne Creek Luxury featuring a polished wooden desk with upholstered guest chairs, a built-in hutch workspace, large floor-to-ceiling windows, textured walls, and natural light that creates a quiet, professional environment for working or studying.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(21).jpg"
    },
    {
      "id": "ec_89bad11221d4c3e3fb1f18ad",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-85dd-739a-b36c-e4b572eab960.webp",
      "image_media": {
        "alt_text": "Reception desk with computer and stone fireplace in apartment community.",
        "public_id": "019d021e-85dd-739a-b36c-e4b572eab960",
        "storage_key": "property/6767906449167186/019d021e-85dd-739a-b36c-e4b572eab960.webp",
        "width": 1023,
        "height": 683
      },
      "title": "Community",
      "description": "Welcome to our community's beautifully appointed reception area, featuring a functional desk and a cozy stone fireplace, perfect for greeting residents and guests.",
      "link": "false",
      "alt_text": "A welcoming business center here at Cheyenne Creek Luxury showcasing a polished wooden desk with a computer workstation, upholstered guest chairs, stone fireplace accents, decorative shelving, and tall windows that allow natural light to fill the professional, comfortable workspace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(22).jpg"
    },
    {
      "id": "ec_92077aa9e163a5d7ef13201a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-87d7-755f-8580-dc4d09ee8641.webp",
      "image_media": {
        "alt_text": "Outdoor patio seating area with tables and chairs overlooking a courtyard with trees and apartment buildings.",
        "public_id": "019d021e-87d7-755f-8580-dc4d09ee8641",
        "storage_key": "property/6767906449167186/019d021e-87d7-755f-8580-dc4d09ee8641.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the fresh air and scenic views from the communal outdoor patio, complete with comfortable seating and tables for relaxation or socializing.",
      "link": "false",
      "alt_text": "A sunlit outdoor patio here at Cheyenne Creek Luxury featuring wrought-iron tables and chairs with red cushions set on a spacious deck, surrounded by mature trees, landscaped greenery, and nearby apartment buildings, creating a peaceful setting for relaxing, socializing, or enjoying fresh air just outside the community clubhouse.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(23).jpg"
    },
    {
      "id": "ec_9a9da92426e3dfb7effb6727",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-9014-718b-97a9-b97d1059529a.webp",
      "image_media": {
        "alt_text": "Covered balcony with a table, chairs, and decorative screen.",
        "public_id": "019d021e-9014-718b-97a9-b97d1059529a",
        "storage_key": "property/6767906449167186/019d021e-9014-718b-97a9-b97d1059529a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy outdoor living on your private covered balcony, furnished with a table and chairs, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "A shaded private patio here at Cheyenne Creek Luxury featuring a round outdoor table with woven chairs, a decorative metal accent, and potted greenery beneath a wood-plank ceiling, offering a quiet, comfortable space for outdoor dining or relaxing while surrounded by mature trees and natural landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(24).jpg"
    },
    {
      "id": "ec_158160fb2e12d24894a36160",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-922d-754f-95ef-32da5fd8e129.webp",
      "image_media": {
        "alt_text": "Covered entryway with a stop sign and low clearance warning.",
        "public_id": "019d021e-922d-754f-95ef-32da5fd8e129",
        "storage_key": "property/6767906449167186/019d021e-922d-754f-95ef-32da5fd8e129.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Drive through the covered entryway, complete with a stop sign and low clearance warning, leading into the community.",
      "link": "false",
      "alt_text": "A covered entrance drive here at Cheyenne Creek Luxury showcasing a peaked roof structure with sturdy columns, surrounded by mature trees and lush greenery, creating a welcoming and shaded arrival area that blends naturally with the landscaped residential setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(25).jpg"
    },
    {
      "id": "ec_38b59cce4b23669c6055797e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-b123-76db-b4ef-e18016eb4999.webp",
      "image_media": {
        "alt_text": "Cheyenne Creek Luxury Apartment Homes sign with mountains and leasing office information.",
        "public_id": "019d021e-b123-76db-b4ef-e18016eb4999",
        "storage_key": "property/6767906449167186/019d021e-b123-76db-b4ef-e18016eb4999.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Welcome sign for Cheyenne Creek Luxury Apartment Homes, directing visitors to the leasing office.",
      "link": "false",
      "alt_text": "A welcoming directional monument sign here at Cheyenne Creek Luxury surrounded by lush green landscaping and mature trees, featuring the community name and leasing office information, with a multi-story apartment building, balconies, and shaded walkways visible softly in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(31).jpg"
    },
    {
      "id": "ec_9f3e9d8510547a85a2d1548a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-aa26-71a6-8f1e-cfb3207d3be3.webp",
      "image_media": {
        "alt_text": "Signage for Cheyenne Creek Luxury Apartment Homes with mountain logo and address numbers 115-175.",
        "public_id": "019d021e-aa26-71a6-8f1e-cfb3207d3be3",
        "storage_key": "property/6767906449167186/019d021e-aa26-71a6-8f1e-cfb3207d3be3.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Welcome to Cheyenne Creek Luxury Apartment Homes. Discover our beautiful community with this exterior signage.",
      "link": "false",
      "alt_text": "A prominent stone monument sign here at Cheyenne Creek Luxury displaying the community name and address, set among manicured green landscaping with tall evergreen trees, shrubs, and a well-maintained lawn, with a multi-story apartment building featuring neutral exterior tones and large windows visible in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(30).jpg"
    },
    {
      "id": "ec_6da60419422244a3b7626f51",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-9518-7595-a78a-f19c87f79856.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily property building with balconies and trees.",
        "public_id": "019d021e-9518-7595-a78a-f19c87f79856",
        "storage_key": "property/6767906449167186/019d021e-9518-7595-a78a-f19c87f79856.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "The exterior of a multifamily property featuring balconies, large windows, and lush landscaping with mature trees.",
      "link": "false",
      "alt_text": "A landscaped apartment exterior here at Cheyenne Creek Luxury featuring a multi-story residential building with neutral-toned stucco, large windows, and private balconies, framed by mature trees, manicured shrubs, and stone-accented greenery that create a peaceful, park-like setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(26).jpg"
    },
    {
      "id": "ec_8647fd12d78f8edf57bf4a72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-9aa0-72ae-956f-e60d6e5756fd.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies and surrounding greenery and seating areas.",
        "public_id": "019d021e-9aa0-72ae-956f-e60d6e5756fd",
        "storage_key": "property/6767906449167186/019d021e-9aa0-72ae-956f-e60d6e5756fd.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "View of the apartment building exterior showcasing balconies, well-maintained landscaping, and outdoor seating areas, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "A serene apartment exterior here at Cheyenne Creek Luxury showcasing multi-story residential buildings with neutral stucco exteriors, private balconies, and large windows, surrounded by mature trees, shaded walking paths, landscaped lawns, benches, and stone-accented greenery that create a peaceful courtyard atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(27).jpg"
    },
    {
      "id": "ec_8e4bcd841d9430ab4fc65732",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-a37d-7529-ab20-c9ad75f40300.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with covered parking area and mature trees.",
        "public_id": "019d021e-a37d-7529-ab20-c9ad75f40300",
        "storage_key": "property/6767906449167186/019d021e-a37d-7529-ab20-c9ad75f40300.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings surrounded by lush trees, featuring a covered parking structure and well-maintained landscaping.",
      "link": "false",
      "alt_text": "A tree-lined apartment exterior here at Cheyenne Creek Luxury featuring multi-story residential buildings with neutral stucco façades, large windows, and architectural accents, set along a quiet drive with a covered entry, manicured lawns, rock landscaping, and mature greenery creating a calm, welcoming community setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(28).jpg"
    },
    {
      "id": "ec_ed5b1858437474aeba9d0e4b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-a503-737e-b0a6-d53d52f9e2b8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and trees.",
        "public_id": "019d021e-a503-737e-b0a6-d53d52f9e2b8",
        "storage_key": "property/6767906449167186/019d021e-a503-737e-b0a6-d53d52f9e2b8.webp",
        "width": 547,
        "height": 365
      },
      "title": "Community",
      "description": "Exterior view of multi-story apartment buildings showcasing balconies and manicured landscaping.",
      "link": "false",
      "alt_text": "A landscaped apartment building exterior here at Cheyenne Creek Luxury showcasing multi-story residences with neutral stucco walls, red accent sections, private balconies, large windows, and a sloped roofline, surrounded by trimmed shrubs, decorative rock landscaping, mature trees, and a well-kept green lawn in a peaceful residential setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(29).jpg"
    },
    {
      "id": "ec_a8c18e7e77f5d6fd707d5aa3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d021e-b244-70a8-9bb6-1c367699bb82.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily building with a covered entryway and mature trees.",
        "public_id": "019d021e-b244-70a8-9bb6-1c367699bb82",
        "storage_key": "property/6767906449167186/019d021e-b244-70a8-9bb6-1c367699bb82.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the multifamily property's exterior, showcasing the building architecture, landscaping, and covered entrance with signage.",
      "link": "false",
      "alt_text": "A scenic exterior view here at Cheyenne Creek Luxury featuring a multi-story apartment building with neutral stucco finishes, large windows, and private balconies, framed by mature trees, landscaped greenery, and a covered drive-through entrance that creates a welcoming arrival experience for residents and guests.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/CO_Cheyenne-Creek-Luxury_Favorites%20(32).jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_84bcdf71-ba21-477d-86b0-52afa5112d23",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Edelweiss German Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "34 E Ramona Ave, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Rustic Bavarian beer garden & eatery where folk music accompanies the classic dishes like schnitzel.",
      "poi_long_description": "Rustic Bavarian beer garden & eatery where folk music accompanies the classic dishes like schnitzel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d25-1d15-7499-8a8b-29acfa6b5544.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d25-1d15-7499-8a8b-29acfa6b5544",
        "storage_key": "property/6767906449167186/01a10d25-1d15-7499-8a8b-29acfa6b5544.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.edelweissrest.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17780159053826741126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edelweiss-german-restaurant",
      "poi_latitude": "38.8098214",
      "poi_longitude": "-104.8248947",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-633-2220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHSleLMJEE4cRhtNJxXTQv_Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "german_restaurant"
    },
    {
      "id": "custom_3e72aaf1-d156-4a92-b389-73afe81f90c4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Marigold Bistro",
      "poi_type": "Restaurants",
      "poi_address": "146 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Upscale choice for modern American fare & diverse wines in stylish environs with a stone fireplace.",
      "poi_long_description": "Upscale choice for modern American fare & diverse wines in stylish environs with a stone fireplace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-86b0-77bd-84c6-6c732a6acb5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-86b0-77bd-84c6-6c732a6acb5c",
        "storage_key": "property/6767906449167186/01a10d27-86b0-77bd-84c6-6c732a6acb5c.webp",
        "width": 1080,
        "height": 810
      },
      "poi_business_url": "https://marigoldbistrocos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3339953298495708955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marigold-bistro",
      "poi_latitude": "38.7903476",
      "poi_longitude": "-104.8237334",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-630-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0a6UJaJEE4cRGx87Q9TlWS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "custom_8484b62a-a444-4b0f-893d-656a3950e691",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "NaRai Siam Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "120 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Relaxed, contemporary restaurant & bar serving classic Thai dishes, including curries & noodles.",
      "poi_long_description": "Relaxed, contemporary restaurant & bar serving classic Thai dishes, including curries & noodles.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-8daf-714b-874d-22b0b266bfdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-8daf-714b-874d-22b0b266bfdd",
        "storage_key": "property/6767906449167186/01a10d27-8daf-714b-874d-22b0b266bfdd.webp",
        "width": 1280,
        "height": 937
      },
      "poi_business_url": "http://www.narai-siam.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16321418708601948172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "narai-siam-cuisine",
      "poi_latitude": "38.790683",
      "poi_longitude": "-104.824155",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-434-1975",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ02EDNaJEE4cRDEiiRNdTgeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_d3780484-7975-41aa-9305-d215b604a6ac",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Miguel's Mexican Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "110 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Area chain serving specialty dishes from all over Mexico in a casual, inviting space.",
      "poi_long_description": "Area chain serving specialty dishes from all over Mexico in a casual, inviting space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-89ce-7382-a3bb-c78abc51f150.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-89ce-7382-a3bb-c78abc51f150",
        "storage_key": "property/6767906449167186/01a10d27-89ce-7382-a3bb-c78abc51f150.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.miguelsmex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3962857603576088220&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miguels-mexican-bar--grill",
      "poi_latitude": "38.7904705",
      "poi_longitude": "-104.824746",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-527-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTywRRKJEE4cRnMabjP7l_jY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_8f87ab66-a6ac-486d-8eca-f7a61cfb69d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "PizzAmoré",
      "poi_type": "Restaurants",
      "poi_address": "236 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Casual pizza restaurant serving Neapolitan-style thin crust and hot honey pizza.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-8709-779b-8b52-5d19709ebb9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-8709-779b-8b52-5d19709ebb9e",
        "storage_key": "property/6767906449167186/01a10d27-8709-779b-8b52-5d19709ebb9e.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.pizzamoreco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5219340818882615995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizzamor",
      "poi_latitude": "38.7901685",
      "poi_longitude": "-104.8235228",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-247-8830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH0oDFqJEE4cRu9oxT9LSbkg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_51a25739-a414-447b-896e-83c0f35a0d4a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "The Public House",
      "poi_type": "Restaurants",
      "poi_address": "445 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Local beer, spirits & American grub offered in a chill setting with sports on TV.",
      "poi_long_description": "Local beer, spirits & American grub offered in a chill setting with sports on TV.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-0d47-7432-a9c9-cd37c90f7741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-0d47-7432-a9c9-cd37c90f7741",
        "storage_key": "property/6767906449167186/019d0223-0d47-7432-a9c9-cd37c90f7741.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://thepublichouseco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14320910237101468842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-public-house",
      "poi_latitude": "38.7884044",
      "poi_longitude": "-104.820617",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-465-3079",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0_bFJ9EE4cRqiywNvwXvsY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_119ac987-d70b-4505-adcd-203c90d0a3e8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Hatch Cover",
      "poi_type": "Restaurants",
      "poi_address": "252 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Neighborhood bar & grill offering pub grub, poker & karaoke nights, plus TV sports for over 40 years",
      "poi_long_description": "Neighborhood bar & grill offering pub grub, poker & karaoke nights, plus TV sports for over 40 years",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-8a88-7258-9a2b-82ec97f5e56a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-8a88-7258-9a2b-82ec97f5e56a",
        "storage_key": "property/6767906449167186/01a10d27-8a88-7258-9a2b-82ec97f5e56a.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://hatchcover.biz/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4520150679722909025&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hatch-cover",
      "poi_latitude": "38.7899818",
      "poi_longitude": "-104.8234024",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-576-5223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ72Uc9qFEE4cRYd0fLBjNuj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_9450e8d9-cf6e-4be7-8ec9-f794652dbde2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Tokki",
      "poi_type": "Restaurants",
      "poi_address": "182 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Lively Korean-fusion lounge serving creative cocktails and artisanal tapas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-8697-71b6-9136-bb09c0a1a95f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-8697-71b6-9136-bb09c0a1a95f",
        "storage_key": "property/6767906449167186/01a10d27-8697-71b6-9136-bb09c0a1a95f.webp",
        "width": 926,
        "height": 618
      },
      "poi_business_url": "http://tokkicolorado.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17548179130234110782&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tokki",
      "poi_latitude": "38.7905141",
      "poi_longitude": "-104.8233981",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-375-0185",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5f45-731c-88d2-c8488b67efd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5f45-731c-88d2-c8488b67efd3",
        "storage_key": "property/6767906449167186/019d0223-5f45-731c-88d2-c8488b67efd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKU-OTtRFE4cRPgOH2PGnh_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_fdbeadef-2d3d-4558-8609-e205745bdbe1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "New Panda",
      "poi_type": "Restaurants",
      "poi_address": "445 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Casual Chinese restaurant serving soups, tofu dishes, and lo mein.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-8a83-70ac-897a-97cbb89ed660.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-8a83-70ac-897a-97cbb89ed660",
        "storage_key": "property/6767906449167186/01a10d27-8a83-70ac-897a-97cbb89ed660.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://order.mealkeyway.com/merchant/6f3359436630586d2f7177426f6262623743563263513d3d/main",
      "poi_directions_map_url": "https://maps.google.com/?cid=6151301060070395244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-panda",
      "poi_latitude": "38.7881248",
      "poi_longitude": "-104.8202039",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-576-9211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkw2cBMBFE4cRbM36H7nPXVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_5f0172e9-acc4-4656-b055-70c60484c2ab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "La Concha Bakery & Coffee",
      "poi_type": "Restaurants",
      "poi_address": "124 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Cozy neighborhood bakery and coffee shop serving artisan Mexican pastries and fresh sourdough bread.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-86b9-76bd-9b3e-bd1dabac5e4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-86b9-76bd-9b3e-bd1dabac5e4c",
        "storage_key": "property/6767906449167186/01a10d27-86b9-76bd-9b3e-bd1dabac5e4c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bakelaconcha.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5762400098695323477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-concha-bakery--coffee",
      "poi_latitude": "38.7906284",
      "poi_longitude": "-104.8241327",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-339-8734",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs4H1i1lFE4cRVR9p-Fso-E8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_95d3836c-a75a-489b-8f2c-47ff3dd677e0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "MOD Pizza",
      "poi_type": "Restaurants",
      "poi_address": "160 E Cheyenne Rd Ste 100, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Counter-serve, industrial-chic chain restaurant known for build-your-own pizzas.",
      "poi_long_description": "Counter-serve, industrial-chic chain restaurant known for build-your-own pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-89ce-7382-a3bb-c8832a38fdb2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-89ce-7382-a3bb-c8832a38fdb2",
        "storage_key": "property/6767906449167186/01a10d27-89ce-7382-a3bb-c8832a38fdb2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.modpizza.com/usa/co/colorado-springs/160-e-cheyenne-rd?utm_source=google&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=13618817907777895735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mod-pizza",
      "poi_latitude": "38.8069797",
      "poi_longitude": "-104.8237368",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 719-355-1271",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXSZu3hlFE4cRN33URbvC_7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_dfec2caa-e37c-4bad-a183-5c8df0e7e2c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Shah Kabob House",
      "poi_type": "Restaurants",
      "poi_address": "829 Cheyenne Meadows Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Afghan restaurant serving flavorful kabobs and authentic Mediterranean staples.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-87d9-7778-993c-dd19a2fc7f89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-87d9-7778-993c-dd19a2fc7f89",
        "storage_key": "property/6767906449167186/01a10d27-87d9-7778-993c-dd19a2fc7f89.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://shahkabobhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15161605575384883276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shah-kabob-house",
      "poi_latitude": "38.7767046",
      "poi_longitude": "-104.8113771",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-434-8932",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdzXiyl1DE4cRTOBl8fDXaNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "afghani_restaurant"
    },
    {
      "id": "custom_8eee89bb-de76-4e00-9a17-a78fe851b35f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "1760 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-8e28-7667-84b7-b0312135b62f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-8e28-7667-84b7-b0312135b62f",
        "storage_key": "property/6767906449167186/01a10d27-8e28-7667-84b7-b0312135b62f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/1020530",
      "poi_directions_map_url": "https://maps.google.com/?cid=16847843706863540619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "38.79532",
      "poi_longitude": "-104.80237",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-475-0466",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5f49-7302-a28e-041eeebfa2cd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5f49-7302-a28e-041eeebfa2cd",
        "storage_key": "property/6767906449167186/019d0223-5f49-7302-a28e-041eeebfa2cd.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJExrdWoZEE4cRi9nmcpaQz-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_b0672c9d-8820-4b28-97f4-4586d61a4740",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Principal's Office",
      "poi_type": "Restaurants",
      "poi_address": "1604 S Cascade Ave, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Playful pub in an old elementary school, offering java, cocktails, all-day eats & a chalkboard bar.",
      "poi_long_description": "Playful pub in an old elementary school, offering java, cocktails, all-day eats & a chalkboard bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-8fc1-76a0-a464-24cf41daf323.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-8fc1-76a0-a464-24cf41daf323",
        "storage_key": "property/6767906449167186/01a10d27-8fc1-76a0-a464-24cf41daf323.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://principalsoffice.co/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4736215984980575591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "principals-office",
      "poi_latitude": "38.81102569999999",
      "poi_longitude": "-104.8275009",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-368-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5f45-731c-88d2-c8488b67efd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5f45-731c-88d2-c8488b67efd3",
        "storage_key": "property/6767906449167186/019d0223-5f45-731c-88d2-c8488b67efd3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB7g_j8NEE4cRZ0VLRFhrukE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_eecded9f-ce54-4d0a-9bd5-4a1e0b41d1f5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "King Soopers",
      "poi_type": "Shopping & Retail",
      "poi_address": "815 Cheyenne Meadows Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Grocery store offering a wide selection of produce and meats.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-a4b7-746a-8c73-b7dff5ef04c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-a4b7-746a-8c73-b7dff5ef04c6",
        "storage_key": "property/6767906449167186/019d0223-a4b7-746a-8c73-b7dff5ef04c6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.kingsoopers.com/stores/grocery/co/colorado-springs/cheyenne-meadows-center/620/00058?cid=loc_62000058_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=12669970701670809835&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-soopers",
      "poi_latitude": "38.7759318",
      "poi_longitude": "-104.8120155",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-527-1590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-63c6-70f9-8891-f0d56f5c2f56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-63c6-70f9-8891-f0d56f5c2f56",
        "storage_key": "property/6767906449167186/019d0223-63c6-70f9-8891-f0d56f5c2f56.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5_cG2VDE4cR6wCyiznH1K8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e6aec635-624c-46df-b515-87c2325ec062",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1720 S Nevada Ave, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-90e2-761a-9967-4d5dcef2e6e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-90e2-761a-9967-4d5dcef2e6e4",
        "storage_key": "property/6767906449167186/01a10d27-90e2-761a-9967-4d5dcef2e6e4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sprouts.com/store/co/colorado-springs/south-nevada-ave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17377437478337615541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "38.8093376",
      "poi_longitude": "-104.8229723",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-719-1957",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-63c6-70f9-8891-f0d56f5c2f56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-63c6-70f9-8891-f0d56f5c2f56",
        "storage_key": "property/6767906449167186/019d0223-63c6-70f9-8891-f0d56f5c2f56.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeB8g_JFE4cRtZbfIlEPKfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3699633f-4b16-40e5-9a2b-76d09afc6ed0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Safeway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1920 S Nevada Ave, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_long_description": "Longtime supermarket chain carrying brand-name & house-label groceries, plus a deli, bakery & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-1461-7398-8056-87d61149eace.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-1461-7398-8056-87d61149eace",
        "storage_key": "property/6767906449167186/019d0223-1461-7398-8056-87d61149eace.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.safeway.com/safeway/co/colorado-springs/1920-s-nevada-ave.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4519195833386663385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway",
      "poi_latitude": "38.8061362",
      "poi_longitude": "-104.8236133",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 719-636-5255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-63c6-70f9-8891-f0d56f5c2f56.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-63c6-70f9-8891-f0d56f5c2f56",
        "storage_key": "property/6767906449167186/019d0223-63c6-70f9-8891-f0d56f5c2f56.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXKRJsBEE4cR2f1vr6potz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_27b64585-72c3-41d1-9fca-431bd2c0b138",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Ivywild Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "311 S Nevada Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.ivywildpharmacy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8417709102095789339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ivywild-pharmacy",
      "poi_latitude": "38.828918",
      "poi_longitude": "-104.821566",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-634-5541",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6867-727c-bea7-cbe4c118b958.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6867-727c-bea7-cbe4c118b958",
        "storage_key": "property/6767906449167186/019d0223-6867-727c-bea7-cbe4c118b958.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdKX-MFEE4cRG-39VNS10XQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_94a1f8fd-dc28-4e9c-9625-247166a373f4",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "1855 Southgate Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9191-766a-960d-3d5bfe87ea3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9191-766a-960d-3d5bfe87ea3a",
        "storage_key": "property/6767906449167186/01a10d27-9191-766a-960d-3d5bfe87ea3a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1855+southgate+rd-colorado+springs-co-80906/id=9767",
      "poi_directions_map_url": "https://maps.google.com/?cid=17458734859147383480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.8065429",
      "poi_longitude": "-104.8207516",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-473-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fc7-731a-9ef2-948e1ed6aa98",
        "storage_key": "property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8PDlOpEE4cRuJI1o9riSfI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_5069266e-8292-42cd-a6b1-38b490df6db0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1630 E Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9345-734b-8c1a-734c4df20d82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9345-734b-8c1a-734c4df20d82",
        "storage_key": "property/6767906449167186/01a10d27-9345-734b-8c1a-734c4df20d82.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/s-colorado-springs/739",
      "poi_directions_map_url": "https://maps.google.com/?cid=15412870885628242247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "38.7925108",
      "poi_longitude": "-104.8018711",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-540-2366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-644e-7422-a41e-e0c92a9b4209",
        "storage_key": "property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnWCMQYdEE4cRR-nU2miE5dU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_cc5c9521-e2fe-4b3e-9055-b488a0092057",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "2150 Southgate Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-932e-721c-b398-6e6f57bc4b9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-932e-721c-b398-6e6f57bc4b9a",
        "storage_key": "property/6767906449167186/01a10d27-932e-721c-b398-6e6f57bc4b9a.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12656606117493462657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "38.8014434",
      "poi_longitude": "-104.8199957",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-471-0011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-644e-7422-a41e-e0c92a9b4209",
        "storage_key": "property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf5zFaZREE4cRgdY7zzRMpa8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_c8a39941-0bea-4d88-9119-29d85003ff43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "Broadmoor Towne Center, 2140 Southgate Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-94a3-732a-9d39-f1802e22a770.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-94a3-732a-9d39-f1802e22a770",
        "storage_key": "property/6767906449167186/01a10d27-94a3-732a-9d39-f1802e22a770.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.michaels.com/CO/Colorado%20Springs/2072/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3776100871266419928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "38.8014666",
      "poi_longitude": "-104.819468",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-475-7580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-644e-7422-a41e-e0c92a9b4209",
        "storage_key": "property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7fvkZ5REE4cR2MTgW7xnZzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_52f2f4d0-d38b-4117-bb64-3b1e4267ac56",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Crumbl Cookies",
      "poi_type": "Restaurants",
      "poi_address": "120 E Cheyenne Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Gourmet cookie shop featuring a rotating selection of fresh, made-from-scratch flavors.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-970d-750c-8f04-15915316c401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-970d-750c-8f04-15915316c401",
        "storage_key": "property/6767906449167186/01a10d27-970d-750c-8f04-15915316c401.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://crumblcookies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1104562555811818789&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crumbl-cookies",
      "poi_latitude": "38.8079836",
      "poi_longitude": "-104.8246996",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-285-0199",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fbe-77fc-a647-b7fb9a42fcf2",
        "storage_key": "property/6767906449167186/019d0223-5fbe-77fc-a647-b7fb9a42fcf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCe1qN99FE4cRJW1c08oxVA8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_55dc8ae5-f433-4797-bb5e-b1327a22e94e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "1877 S Nevada Ave, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-94f8-7008-ae1a-1dc4bd8dfe97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-94f8-7008-ae1a-1dc4bd8dfe97",
        "storage_key": "property/6767906449167186/01a10d27-94f8-7008-ae1a-1dc4bd8dfe97.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.dollartree.com/co/colorado-springs/1877-s-nevada-ave?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=12724692752208770471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "38.8070665",
      "poi_longitude": "-104.8203888",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-559-0135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-644e-7422-a41e-e0c92a9b4209",
        "storage_key": "property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJv-CLgepEE4cRpzVky6Mwl7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_af6151cf-0569-4733-ab1a-d02c0549a2ae",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Cheyenne Mountain Junior High School",
      "poi_type": "Education",
      "poi_address": "1200 W Cheyenne Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://cmjh.cmsd12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1755740468428033663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheyenne-mountain-junior-high-school",
      "poi_latitude": "38.79951399999999",
      "poi_longitude": "-104.8498309",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 719-475-6120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLQ14R0pbE4cRf05uWqekXRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a6968102-80c9-41f5-9197-d1df15223c6a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Cheyenne Mountain High School",
      "poi_type": "Education",
      "poi_address": "1200 Cresta Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9594-76ca-9f75-4d02c3586a0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9594-76ca-9f75-4d02c3586a0c",
        "storage_key": "property/6767906449167186/01a10d27-9594-76ca-9f75-4d02c3586a0c.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://cmhs.cmsd12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=990713605558648341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheyenne-mountain-high-school",
      "poi_latitude": "38.803108",
      "poi_longitude": "-104.857249",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-475-6110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLQ14R0pbE4cRFT54dca4vw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_61aab806-9cda-4b19-9af1-4462fb502cbe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Canon School",
      "poi_type": "Education",
      "poi_address": "1201 W Cheyenne Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://canon.cmsd12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939713743438550163&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "canon-school",
      "poi_latitude": "38.7986161",
      "poi_longitude": "-104.8483306",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-475-6140",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCwSAqktbE4cRkxTFWXpjjUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_659d9f21-d52a-4b36-9f8c-884a65c2943d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Broadmoor Elementary School",
      "poi_type": "Education",
      "poi_address": "440 W Cheyenne Mountain Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-957e-719a-a98b-a30f0ca166c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-957e-719a-a98b-a30f0ca166c8",
        "storage_key": "property/6767906449167186/01a10d27-957e-719a-a98b-a30f0ca166c8.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://bmoor.cmsd12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13825597070414294314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "broadmoor-elementary-school",
      "poi_latitude": "38.7897759",
      "poi_longitude": "-104.8360169",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-475-6130",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2c-ZCK9EE4cRKq25zUhj3r8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_6b4bbcd5-1d61-4e7f-ae3c-b6d2e3b63e5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Skyway Park Elementary School",
      "poi_type": "Education",
      "poi_address": "1100 Mercury Dr, Colorado Springs, CO 80905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-1f4e-7489-bbfc-05d3f1953b69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-1f4e-7489-bbfc-05d3f1953b69",
        "storage_key": "property/6767906449167186/019d0223-1f4e-7489-bbfc-05d3f1953b69.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://skyway.cmsd12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2266425788516536314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "skyway-park-elementary-school",
      "poi_latitude": "38.8061265",
      "poi_longitude": "-104.849725",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-475-6150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj3IS9TNbE4cR-g9QIj_2cx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_277811be-c5f1-4abc-a630-953112deb308",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Oak Creek Elementary School",
      "poi_type": "Education",
      "poi_address": "3333 Oak Creek Dr W, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://oces.hsd2.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5048720797359736306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-creek-elementary-school",
      "poi_latitude": "38.7836061",
      "poi_longitude": "-104.8176736",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-579-2175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2e8Y7WFDE4cR8gXB4NCoEEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_80c890ac-c20b-4b6a-aa08-4e76dc005bee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Gold Camp Elementary School",
      "poi_type": "Education",
      "poi_address": "1805 Preserve Dr, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-241f-73bb-aea8-676baed80593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-241f-73bb-aea8-676baed80593",
        "storage_key": "property/6767906449167186/019d0223-241f-73bb-aea8-676baed80593.webp",
        "width": 1280,
        "height": 821
      },
      "poi_business_url": "https://gce.cmsd12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8356447730138457234&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gold-camp-elementary-school",
      "poi_latitude": "38.8079742",
      "poi_longitude": "-104.8597821",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-327-2820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJve9P_DpbE4cRkqQFq-8Q-HM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_67490d18-8582-4673-b088-3922901545f8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Piñon Valley Elementary School",
      "poi_type": "Education",
      "poi_address": "6205 Farthing Dr, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://pve.cmsd12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10221950881633516992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pion-valley-elementary-school",
      "poi_latitude": "38.75697",
      "poi_longitude": "-104.814022",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 719-527-0300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDXDT_BBDE4cRwL1BKyuq240",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f02de09e-54c3-4653-b76a-22531ba3cb9b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "The Vanguard School",
      "poi_type": "Education",
      "poi_address": "1605 S Corona Ave, Colorado Springs, CO 80905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9743-733b-83cb-87a44d0ad874.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9743-733b-83cb-87a44d0ad874",
        "storage_key": "property/6767906449167186/01a10d27-9743-733b-83cb-87a44d0ad874.webp",
        "width": 1280,
        "height": 926
      },
      "poi_business_url": "http://www.thevanguardschool.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14070946964424599832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-vanguard-school",
      "poi_latitude": "38.8112212",
      "poi_longitude": "-104.8157286",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-471-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi9--AetEE4cRGKnji7YLRsM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_16a29c41-a509-4589-8f34-8081aa28673c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "University of Colorado Colorado Springs",
      "poi_type": "Education",
      "poi_address": "1420 Austin Bluffs Pkwy, Colorado Springs, CO 80918, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9969-77d9-83c6-36de9609a010.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9969-77d9-83c6-36de9609a010",
        "storage_key": "property/6767906449167186/01a10d27-9969-77d9-83c6-36de9609a010.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://www.uccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10577512112395933892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-colorado-colorado-springs",
      "poi_latitude": "38.8928151",
      "poi_longitude": "-104.8007996",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 719-255-8227",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTn-iKBPE4cRxFjAYjnfypI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7520cc74-5c36-4506-9f54-2ea6652db4b3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "The Broadmoor",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Lake Ave, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Elegant resort accommodations & dining options, plus a spa, a golf course & outdoor activities.",
      "poi_long_description": "Elegant resort accommodations & dining options, plus a spa, a golf course & outdoor activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-4dbc-71f5-8f5b-2ed33f434f97.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-4dbc-71f5-8f5b-2ed33f434f97",
        "storage_key": "property/6767906449167186/019d0223-4dbc-71f5-8f5b-2ed33f434f97.webp",
        "width": 1280,
        "height": 633
      },
      "poi_business_url": "https://www.broadmoor.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12783829887957334741&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadmoor",
      "poi_latitude": "38.7910791",
      "poi_longitude": "-104.8499124",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-634-7711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6c00-73f8-be02-604054e83c6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6c00-73f8-be02-604054e83c6e",
        "storage_key": "property/6767906449167186/019d0223-6c00-73f8-be02-604054e83c6e.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJ2S2v31FbE4cR1fq3LI1JabE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "resort_hotel"
    },
    {
      "id": "custom_5d4cdefa-7bdf-4e98-ba01-618afdc1ef21",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "The Broadmoor World Arena",
      "poi_type": "Entertainment",
      "poi_address": "3185 Venetucci Blvd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Arena with events such as concerts & comedy shows plus an ice hall with hockey & figure skating.",
      "poi_long_description": "Arena with events such as concerts & comedy shows plus an ice hall with hockey & figure skating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-29a4-778d-af34-e3812b2cddde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-29a4-778d-af34-e3812b2cddde",
        "storage_key": "property/6767906449167186/019d0223-29a4-778d-af34-e3812b2cddde.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.broadmoorworldarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15763854442163136597&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadmoor-world-arena",
      "poi_latitude": "38.7882819",
      "poi_longitude": "-104.7942332",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-477-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d25-403b-7519-8db6-b6816210ce3c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d25-403b-7519-8db6-b6816210ce3c",
        "storage_key": "property/6767906449167186/01a10d25-403b-7519-8db6-b6816210ce3c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJxfyXXn9EE4cRVegYPBh2xNo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_89973d3e-2e99-415a-9f1f-c2f7af6bae4d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Cheyenne Mountain Zoo",
      "poi_type": "Entertainment",
      "poi_address": "4250 Cheyenne Mountain Zoo Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Prominent conservation park with 700+ animals known for its big giraffe herd & feeding experiences.",
      "poi_long_description": "Prominent conservation park with 700+ animals known for its big giraffe herd & feeding experiences.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d25-2308-71db-8e6a-5e5fd44d290d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d25-2308-71db-8e6a-5e5fd44d290d",
        "storage_key": "property/6767906449167186/01a10d25-2308-71db-8e6a-5e5fd44d290d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.cmzoo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10507210585571489614&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheyenne-mountain-zoo",
      "poi_latitude": "38.7703872",
      "poi_longitude": "-104.8548688",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-633-9925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d25-403e-7143-857e-56c30312047c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d25-403e-7143-857e-56c30312047c",
        "storage_key": "property/6767906449167186/01a10d25-403e-7143-857e-56c30312047c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk6vByq9cE4cRTnc2pVsc0ZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "zoo"
    },
    {
      "id": "custom_73d03f91-f654-4d9b-b5a7-830d70b0beba",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Starsmore Visitor and Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "2120 S Cheyenne Canyon Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Cheyenne Canyon information & interactive exhibits, plus seasonal nature programming & guided hikes.",
      "poi_long_description": "Cheyenne Canyon information & interactive exhibits, plus seasonal nature programming & guided hikes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9c2e-76c3-8aed-a3b0d19336bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9c2e-76c3-8aed-a3b0d19336bb",
        "storage_key": "property/6767906449167186/01a10d27-9c2e-76c3-8aed-a3b0d19336bb.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://coloradosprings.gov/Starsmore",
      "poi_directions_map_url": "https://maps.google.com/?cid=3745345510114640876&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starsmore-visitor-and-nature-center",
      "poi_latitude": "38.7909594",
      "poi_longitude": "-104.8652877",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-385-6086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-bfa0-77db-8b1c-d4ffe48672c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d27-bfa0-77db-8b1c-d4ffe48672c4",
        "storage_key": "property/6767906449167186/01a10d27-bfa0-77db-8b1c-d4ffe48672c4.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJWbezQGRbE4cR7MN80-Uj-jM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_4568d478-8fbf-4806-a0f2-df850c0707da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "The Broadmoor Seven Falls",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1045 Lower Gold Camp Rd, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Park focused on scenic waterfalls & geologic monuments that also has a historic gravesite.",
      "poi_long_description": "Park focused on scenic waterfalls & geologic monuments that also has a historic gravesite.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d25-2d18-749a-a362-410002e01520.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d25-2d18-749a-a362-410002e01520",
        "storage_key": "property/6767906449167186/01a10d25-2d18-749a-a362-410002e01520.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sevenfalls.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8987375542602143609&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-broadmoor-seven-falls",
      "poi_latitude": "38.8231309",
      "poi_longitude": "-104.8487188",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 855-923-7272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d25-403d-7597-b656-642c1256e30c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d25-403d-7597-b656-642c1256e30c",
        "storage_key": "property/6767906449167186/01a10d25-403d-7597-b656-642c1256e30c.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJmaCcQGRbE4cReZfVV3CSuXw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_91b0833f-3909-45a0-8eae-a3900d4f5104",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Garden of the Gods Visitor & Nature Center",
      "poi_type": "Entertainment",
      "poi_address": "1805 N 30th St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "Educational visitor center offering park history exhibits, guided outdoor tours, and on-site dining and shopping.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-2cdd-7298-a5d4-b2bb303f783e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-2cdd-7298-a5d4-b2bb303f783e",
        "storage_key": "property/6767906449167186/019d0223-2cdd-7298-a5d4-b2bb303f783e.webp",
        "width": 1280,
        "height": 334
      },
      "poi_business_url": "https://gardenofgods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6587710856062110015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garden-of-the-gods-visitor--nature-center",
      "poi_latitude": "38.8783986",
      "poi_longitude": "-104.8697704",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 719-634-6666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-686a-727e-bb92-4f1c8b7bc095.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-686a-727e-bb92-4f1c8b7bc095",
        "storage_key": "property/6767906449167186/019d0223-686a-727e-bb92-4f1c8b7bc095.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6oa22pQE4cRPwmR0h5AbFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_597df30c-4bcd-4df0-8462-478897e7ea81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Rock Ledge Ranch Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "3105 Gateway Rd, Colorado Springs, CO 80904, USA",
      "poi_short_description": "Scenic park with old-fashioned houses & interpretive guides depicting farm life from 1775 to 1907.",
      "poi_long_description": "Scenic park with old-fashioned houses & interpretive guides depicting farm life from 1775 to 1907.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9c3b-71cf-9705-e8d5e154dd51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9c3b-71cf-9705-e8d5e154dd51",
        "storage_key": "property/6767906449167186/01a10d27-9c3b-71cf-9705-e8d5e154dd51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rockledgeranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12594802948814956425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-ledge-ranch-historic-site",
      "poi_latitude": "38.8772719",
      "poi_longitude": "-104.8714347",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 719-578-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-bfc6-739c-a775-4661ac1eb84e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d27-bfc6-739c-a775-4661ac1eb84e",
        "storage_key": "property/6767906449167186/01a10d27-bfc6-739c-a775-4661ac1eb84e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXa7n_mxQE4cRiWcoRI26ya4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_307fe51c-e2f1-4fb3-8563-47b67fc3e99b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Pikes Peak Center For The Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "190 S Cascade Ave, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Performing arts theater hosting diverse concerts, symphonies, and live performances.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-2ef7-730c-9658-62bb88e16ca5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-2ef7-730c-9658-62bb88e16ca5",
        "storage_key": "property/6767906449167186/019d0223-2ef7-730c-9658-62bb88e16ca5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.pikespeakcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11500179945342731688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pikes-peak-center-for-the-performing-arts",
      "poi_latitude": "38.8309234",
      "poi_longitude": "-104.8265795",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-477-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-bfac-76b1-93a8-83aaa45265a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d27-bfac-76b1-93a8-83aaa45265a1",
        "storage_key": "property/6767906449167186/01a10d27-bfac-76b1-93a8-83aaa45265a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJScDMxCNFE4cRqIU5z7rYmJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_bd158e33-cd87-45a8-85b5-7d03fa87f75c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Cave of the Winds Mountain Park",
      "poi_type": "Entertainment",
      "poi_address": "100 Cave of the Winds Rd, Manitou Springs, CO 80829, USA",
      "poi_short_description": "This historic cave has several tour options, including spelunking, plus a zip line & ropes course.",
      "poi_long_description": "This historic cave has several tour options, including spelunking, plus a zip line & ropes course.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-31a1-7129-afca-aa9e3b360b46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-31a1-7129-afca-aa9e3b360b46",
        "storage_key": "property/6767906449167186/019d0223-31a1-7129-afca-aa9e3b360b46.webp",
        "width": 431,
        "height": 450
      },
      "poi_business_url": "https://caveofthewinds.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9929591581785700776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cave-of-the-winds-mountain-park",
      "poi_latitude": "38.8725916",
      "poi_longitude": "-104.9201269",
      "poi_miles_from_property": "12.5",
      "poi_walking_minutes": "5 hours 7 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 719-685-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-bfa0-77db-8b1c-d4ffe48672c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d27-bfa0-77db-8b1c-d4ffe48672c4",
        "storage_key": "property/6767906449167186/01a10d27-bfa0-77db-8b1c-d4ffe48672c4.webp",
        "width": 192,
        "height": 139
      },
      "poi_google_place_id": "ChIJk9YPNLlQE4cRqLkLNe_-zIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_13be069d-2bfa-42cc-b7d9-7e1683daae44",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Iron Springs Chateau",
      "poi_type": "Entertainment",
      "poi_address": "444 Ruxton Ave, Manitou Springs, CO 80829, USA",
      "poi_short_description": "Cheery dinner theater featuring old-fashioned comedic melodramas & hearty American eats.",
      "poi_long_description": "Cheery dinner theater featuring old-fashioned comedic melodramas & hearty American eats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-a02d-73bd-9992-92b1d70fc795.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-a02d-73bd-9992-92b1d70fc795",
        "storage_key": "property/6767906449167186/01a10d27-a02d-73bd-9992-92b1d70fc795.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://ironspringschateau.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14857618407064665501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-springs-chateau",
      "poi_latitude": "38.856341",
      "poi_longitude": "-104.930161",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 719-685-5104",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-bfac-76b1-93a8-83aaa45265a1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d27-bfac-76b1-93a8-83aaa45265a1",
        "storage_key": "property/6767906449167186/01a10d27-bfac-76b1-93a8-83aaa45265a1.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpUq42qhQE4cRnf1k4TjdMM4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_2bdababd-b962-4ad5-9467-fc574b3bd2be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "CommonSpirit Penrose Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2222 N Nevada Ave, Colorado Springs, CO 80907, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-3e36-7414-9027-1ea34fbbde4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-3e36-7414-9027-1ea34fbbde4d",
        "storage_key": "property/6767906449167186/019d0223-3e36-7414-9027-1ea34fbbde4d.webp",
        "width": 800,
        "height": 551
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/penrose-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=16350633166847560439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-penrose-hospital",
      "poi_latitude": "38.8661872",
      "poi_longitude": "-104.8224825",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 719-776-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6900-7280-b098-17f0c0f0a383.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6900-7280-b098-17f0c0f0a383",
        "storage_key": "property/6767906449167186/019d0223-6900-7280-b098-17f0c0f0a383.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJAd9SD2BFE4cR90qrYjwe6eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ff21547b-6e03-4d24-a111-2b1e172e5349",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "CommonSpirit Urgent Care Broadmoor",
      "poi_type": "Health and Wellness",
      "poi_address": "1263 Lake Plaza Dr #120, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9f98-709f-96cd-81898ef23d0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9f98-709f-96cd-81898ef23d0f",
        "storage_key": "property/6767906449167186/01a10d27-9f98-709f-96cd-81898ef23d0f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/commonspirit-urgent-care-broadmoor",
      "poi_directions_map_url": "https://maps.google.com/?cid=17448804333151316593&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-urgent-care-broadmoor",
      "poi_latitude": "38.7942504",
      "poi_longitude": "-104.8041962",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 719-776-3330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fc7-731a-9ef2-948e1ed6aa98",
        "storage_key": "property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIzFUh4ZEE4cRcerH4BebJvI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_a0bc98ea-ab17-418a-8712-db6ac25e1fc6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "UCHealth Urgent Care - Circle Square",
      "poi_type": "Health and Wellness",
      "poi_address": "2767 Janitell Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9e8c-72ef-a445-ea5b75af34e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9e8c-72ef-a445-ea5b75af34e4",
        "storage_key": "property/6767906449167186/01a10d27-9e8c-72ef-a445-ea5b75af34e4.webp",
        "width": 750,
        "height": 500
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-urgent-care-circle-square-colorado-springs/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9414300827440141751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-urgent-care---circle-square",
      "poi_latitude": "38.7941959",
      "poi_longitude": "-104.7878754",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-365-2888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fc7-731a-9ef2-948e1ed6aa98",
        "storage_key": "property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-CFG3pEE4cRt1U8NLlQpoI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_32310c3d-f1a6-4236-bc2e-d1883053dc70",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1855 Southgate Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-9fa4-7154-8526-d877237d0507.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-9fa4-7154-8526-d877237d0507",
        "storage_key": "property/6767906449167186/01a10d27-9fa4-7154-8526-d877237d0507.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1855+southgate+rd-colorado+springs-co-80906/id=9767",
      "poi_directions_map_url": "https://maps.google.com/?cid=1288984302452007870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "38.8065538",
      "poi_longitude": "-104.8207618",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 719-473-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6867-727c-bea7-cbe4c118b958.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6867-727c-bea7-cbe4c118b958",
        "storage_key": "property/6767906449167186/019d0223-6867-727c-bea7-cbe4c118b958.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl5SdlOpEE4cRvuO0zGRk4xE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_004d3bd8-fbb8-4a99-a401-1c270c7da61a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Safeway Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1920 S Nevada Ave, Colorado Springs, CO 80905, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-a4cd-763a-81c6-42c1c7da1dfe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-a4cd-763a-81c6-42c1c7da1dfe",
        "storage_key": "property/6767906449167186/01a10d27-a4cd-763a-81c6-42c1c7da1dfe.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://local.pharmacy.safeway.com/safeway/co/colorado-springs/1920-s-nevada-ave.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=16131624882331615309&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "safeway-pharmacy",
      "poi_latitude": "38.8061111",
      "poi_longitude": "-104.8233666",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-636-5257",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6867-727c-bea7-cbe4c118b958.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6867-727c-bea7-cbe4c118b958",
        "storage_key": "property/6767906449167186/019d0223-6867-727c-bea7-cbe4c118b958.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBXKRJsBEE4cRTYA6iVwL398",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_2f2db3a2-8121-4ee3-adf4-7a3117784a76",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "King Soopers Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "815 Cheyenne Meadows Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-a22d-723d-b79e-3f59044114cb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-a22d-723d-b79e-3f59044114cb",
        "storage_key": "property/6767906449167186/01a10d27-a22d-723d-b79e-3f59044114cb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kingsoopers.com/rx/pharmacy/details/620/00058?cid=loc_62000058P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14152802898752268254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "king-soopers-pharmacy",
      "poi_latitude": "38.7759844",
      "poi_longitude": "-104.8120138",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-527-1640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6867-727c-bea7-cbe4c118b958.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6867-727c-bea7-cbe4c118b958",
        "storage_key": "property/6767906449167186/019d0223-6867-727c-bea7-cbe4c118b958.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5_cG2VDE4cR3mc_bEDbaMQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_29c19411-9195-4842-83e1-48873a04d4e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Flylife Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "750 Garden of the Gods Rd #104, Colorado Springs, CO 80907, USA",
      "poi_short_description": "Clean fitness studio specializing in Lagree Fitness total-body strength training via the Megaformer machine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-a01b-71c4-9715-8874641dc884.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-a01b-71c4-9715-8874641dc884",
        "storage_key": "property/6767906449167186/01a10d27-a01b-71c4-9715-8874641dc884.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://flylifefitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15382080050421390358&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flylife-fitness",
      "poi_latitude": "38.8970603",
      "poi_longitude": "-104.8401107",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-396-0615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fc7-731a-9ef2-948e1ed6aa98",
        "storage_key": "property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXyDj6oZOE4cRFlz9304geNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_ca23a175-593a-46ab-9d0c-62dd82024342",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "CorePower Yoga - Garden of the Gods",
      "poi_type": "Health and Wellness",
      "poi_address": "1025 Garden of the Gods Rd C, Colorado Springs, CO 80907, USA",
      "poi_short_description": "Yoga-focused studio for hot and other forms of yoga for all levels including sculpt and vinyasa.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-a3a7-777c-b2f4-003c9cea89dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-a3a7-777c-b2f4-003c9cea89dd",
        "storage_key": "property/6767906449167186/01a10d27-a3a7-777c-b2f4-003c9cea89dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/co/colorado-springs/garden-of-the-gods",
      "poi_directions_map_url": "https://maps.google.com/?cid=9420516433593894645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---garden-of-the-gods",
      "poi_latitude": "38.8961249",
      "poi_longitude": "-104.8408577",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrYYpGddPE4cR9QYYychlvII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_779f5d1d-f9bd-4068-b141-bcd8b2a7eecc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "One Body Fitness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "710 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Welcoming Pilates-based workout studio offering classes and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-a4d5-76ea-8ebf-87cde33f25b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-a4d5-76ea-8ebf-87cde33f25b2",
        "storage_key": "property/6767906449167186/01a10d27-a4d5-76ea-8ebf-87cde33f25b2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.onebodyfitnessstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4220481538926425412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "one-body-fitness-studio",
      "poi_latitude": "38.8240439",
      "poi_longitude": "-104.8244173",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 719-685-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fc7-731a-9ef2-948e1ed6aa98",
        "storage_key": "property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz4al1rpFE4cRRLXNPJkpkjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_e47da72a-599f-4b5b-ab38-06773bd70ad3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Fit 365",
      "poi_type": "Health and Wellness",
      "poi_address": "25 N Cascade Ave Ste 90, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Gym requiring membership with equipment and parking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-a52f-71af-817a-acce0de4bf29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-a52f-71af-817a-acce0de4bf29",
        "storage_key": "property/6767906449167186/01a10d27-a52f-71af-817a-acce0de4bf29.webp",
        "width": 1200,
        "height": 674
      },
      "poi_business_url": "http://www.fit365downtown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1782234100256620740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fit-365",
      "poi_latitude": "38.8348642",
      "poi_longitude": "-104.8250443",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-471-3935",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fc7-731a-9ef2-948e1ed6aa98",
        "storage_key": "property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDy0j1SJFE4cRxEBitHjEuxg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_32fb5519-3b7a-4ac3-8b39-9b15177f68ef",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Helen Hunt Falls Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "3440 N Cheyenne Canyon Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Picturesque visitor center featuring scenic waterfall views and easy hiking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-a81a-7603-a769-60bf5f0b1461.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-a81a-7603-a769-60bf5f0b1461",
        "storage_key": "property/6767906449167186/01a10d27-a81a-7603-a769-60bf5f0b1461.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://cheyennecanon.org/visitor-centers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2549307429771024157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "helen-hunt-falls-visitor-center",
      "poi_latitude": "38.7889065",
      "poi_longitude": "-104.9030777",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-633-5701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fc7-731a-9ef2-948e1ed6aa98",
        "storage_key": "property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5UONG5pbE4cRHRfEvpn1YCM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_59f593e8-15ea-41ee-b276-af73663cc3fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Red Rock Canyon",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3550 W High St, Colorado Springs, CO 80904, USA",
      "poi_short_description": "City preserve with marked walking & biking trails, as well as scenic views of red-rock formations.",
      "poi_long_description": "City preserve with marked walking & biking trails, as well as scenic views of red-rock formations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d25-33b8-77d1-89bb-86c06710f649.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d25-33b8-77d1-89bb-86c06710f649",
        "storage_key": "property/6767906449167186/01a10d25-33b8-77d1-89bb-86c06710f649.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://redrockcanyonopenspace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15444699715466012842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "red-rock-canyon",
      "poi_latitude": "38.8518656",
      "poi_longitude": "-104.8784924",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-385-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d25-403d-7597-b656-642c1256e30c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d25-403d-7597-b656-642c1256e30c",
        "storage_key": "property/6767906449167186/01a10d25-403d-7597-b656-642c1256e30c.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJm4OCqpxaE4cRqqjtyo-YVtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_58dcc257-c79f-450c-a280-51f626d6c965",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Cheyenne Mountain State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "410 JL Ranch Heights Rd, Colorado Springs, CO 80926, USA",
      "poi_short_description": "Huge, scenic state park with biking & hiking trails, picnicking, a campground & other features.",
      "poi_long_description": "Huge, scenic state park with biking & hiking trails, picnicking, a campground & other features.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d25-3026-77d8-b6af-9d0eb8e329b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d25-3026-77d8-b6af-9d0eb8e329b1",
        "storage_key": "property/6767906449167186/01a10d25-3026-77d8-b6af-9d0eb8e329b1.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://cpw.state.co.us/placestogo/parks/CheyenneMountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=3270001252430168449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheyenne-mountain-state-park",
      "poi_latitude": "38.7291548",
      "poi_longitude": "-104.83288",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 16 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 719-576-2016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6c03-77ea-9364-20912eab3029.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6c03-77ea-9364-20912eab3029",
        "storage_key": "property/6767906449167186/019d0223-6c03-77ea-9364-20912eab3029.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWTahD8VCE4cRgcEuWtBgYS0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_f83b6371-0016-436b-a09e-d1d2374c2785",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Ivywild Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1660 Dorchester Dr, Colorado Springs, CO 80905, USA",
      "poi_short_description": "Quiet neighborhood park featuring a playground for children.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-a8e6-775d-bedd-62ace8961fad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-a8e6-775d-bedd-62ace8961fad",
        "storage_key": "property/6767906449167186/01a10d27-a8e6-775d-bedd-62ace8961fad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/parks/page/neighborhood-parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=12437386683123573738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ivywild-park",
      "poi_latitude": "38.8109999",
      "poi_longitude": "-104.8302311",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 719-385-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6c03-77ea-9364-20912eab3029.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6c03-77ea-9364-20912eab3029",
        "storage_key": "property/6767906449167186/019d0223-6c03-77ea-9364-20912eab3029.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQw_PUMREE4cR6iPBzUp5mqw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9fa22d72-e3f6-4bb5-93d3-2d52b331804f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Monument Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "170 W Cache La Poudre St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "Century-old park with ballfields & paths for running & cycling, plus a pool & formal gardens.",
      "poi_long_description": "Century-old park with ballfields & paths for running & cycling, plus a pool & formal gardens.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-aa09-772d-8df0-6d7af5b8cffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-aa09-772d-8df0-6d7af5b8cffd",
        "storage_key": "property/6767906449167186/01a10d27-aa09-772d-8df0-6d7af5b8cffd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://coloradosprings.gov/parks/page/monument-valley-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13621370286329543394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monument-valley-park",
      "poi_latitude": "38.8465688",
      "poi_longitude": "-104.8280831",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6c03-77ea-9364-20912eab3029.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6c03-77ea-9364-20912eab3029",
        "storage_key": "property/6767906449167186/019d0223-6c03-77ea-9364-20912eab3029.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9yQ_YURFE4cR4rq7NhvUCL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_586b827e-b00e-4f0c-9ee1-2d5eeae5be5b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Ute Valley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1705 Vindicator Dr, Colorado Springs, CO 80919, USA",
      "poi_short_description": "Hiking & biking trails snake through this park that spans a hogback ridge & offers scenic views.",
      "poi_long_description": "Hiking & biking trails snake through this park that spans a hogback ridge & offers scenic views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-aa41-7491-8550-211f96b285fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-aa41-7491-8550-211f96b285fb",
        "storage_key": "property/6767906449167186/01a10d27-aa41-7491-8550-211f96b285fb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://coloradosprings.gov/parks/page/ute-valley-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10862138569670806669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ute-valley-park",
      "poi_latitude": "38.9250864",
      "poi_longitude": "-104.8581194",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 58 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 719-385-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6c03-77ea-9364-20912eab3029.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6c03-77ea-9364-20912eab3029",
        "storage_key": "property/6767906449167186/019d0223-6c03-77ea-9364-20912eab3029.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe9Fqr9xRE4cRjUxMonoRvpY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c70ef81c-089b-4a4e-bb06-8e4d2fecbf86",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Bear Creek Nature Center",
      "poi_type": "Education",
      "poi_address": "245 Bear Creek Rd, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Wildlife, nature trails & a variety of habitats featured at a preserve with guided tours & events.",
      "poi_long_description": "Wildlife, nature trails & a variety of habitats featured at a preserve with guided tours & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-aaff-71a9-8d7a-d3315d312f74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-aaff-71a9-8d7a-d3315d312f74",
        "storage_key": "property/6767906449167186/01a10d27-aaff-71a9-8d7a-d3315d312f74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://communityservices.elpasoco.com/nature-centers/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9643867229157335752&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek-nature-center",
      "poi_latitude": "38.8294281",
      "poi_longitude": "-104.878664",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 719-520-6387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-64d8-7408-ba23-fa6b4118f91e",
        "storage_key": "property/6767906449167186/019d0223-64d8-7408-ba23-fa6b4118f91e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6SAIlOVaE4cRyCL0Ribm1YU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_6cd91ac5-eefd-4918-b5f2-7e678cd3e4a7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Metro Downtown Bus Terminal",
      "poi_type": "Transportation & Transit",
      "poi_address": "127 E Kiowa St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-ad61-7195-bf54-a23407541593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-ad61-7195-bf54-a23407541593",
        "storage_key": "property/6767906449167186/01a10d27-ad61-7195-bf54-a23407541593.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16550523255779328766&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-downtown-bus-terminal",
      "poi_latitude": "38.834925",
      "poi_longitude": "-104.8220235",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 719-385-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fc7-731a-9ef2-948e1ed6aa98",
        "storage_key": "property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDABxhFE4cR_oKRczZFr-U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_7f2307fb-d9c7-41cc-abd1-8a0ac07d8681",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Mountain Metropolitan Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "1015 Transit Dr, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-ab0e-744c-83fd-f42720d2fd40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-ab0e-744c-83fd-f42720d2fd40",
        "storage_key": "property/6767906449167186/01a10d27-ab0e-744c-83fd-f42720d2fd40.webp",
        "width": 1280,
        "height": 1279
      },
      "poi_business_url": "http://mmtransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=722502473995738549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-metropolitan-transit",
      "poi_latitude": "38.8189618",
      "poi_longitude": "-104.8050417",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 719-385-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6c2b-75b1-8a27-5820d6c9cf17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6c2b-75b1-8a27-5820d6c9cf17",
        "storage_key": "property/6767906449167186/019d0223-6c2b-75b1-8a27-5820d6c9cf17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZnOIvpEE4cRtV3bDyzYBgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_a9d7c623-192d-4a89-8c7a-fd1b9f3204b9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Colorado Springs Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7770 Milton E Proby Pkwy, Colorado Springs, CO 80916, USA",
      "poi_short_description": "This municipal airport featuring permanent & rotating art exhibitions also offers free WiFi.",
      "poi_long_description": "This municipal airport featuring permanent & rotating art exhibitions also offers free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-adaa-7096-80f3-b8e43cda3e8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-adaa-7096-80f3-b8e43cda3e8b",
        "storage_key": "property/6767906449167186/01a10d27-adaa-7096-80f3-b8e43cda3e8b.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.flycos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5054110453719476621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-airport",
      "poi_latitude": "38.8036959",
      "poi_longitude": "-104.7112051",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 719-550-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-de5c-70f0-aa4a-cc6655f3544f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-de5c-70f0-aa4a-cc6655f3544f",
        "storage_key": "property/6767906449167186/019d0223-de5c-70f0-aa4a-cc6655f3544f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQvRTypHE4cRjamJCa7OI0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_ef81b113-9a55-4e90-a71d-e01d601b2192",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Colorado Springs Tejon Park-N-Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "1251 S Tejon St, Colorado Springs, CO 80903, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15928408554245266606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colorado-springs-tejon-park-n-ride",
      "poi_latitude": "38.8154971",
      "poi_longitude": "-104.8235017",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-5fc7-731a-9ef2-948e1ed6aa98",
        "storage_key": "property/6767906449167186/019d0223-5fc7-731a-9ef2-948e1ed6aa98.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcfOKRgBFE4cRrhwVETATDd0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_f1685f40-3859-43c2-bce2-9d88471e2722",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Woodmen Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "6910 Mark Dabling Blvd, Colorado Springs, CO 80919, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-ae21-7788-a765-79d9c79c0ece.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-ae21-7788-a765-79d9c79c0ece",
        "storage_key": "property/6767906449167186/01a10d27-ae21-7788-a765-79d9c79c0ece.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3052945528737043137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodmen-park-and-ride",
      "poi_latitude": "38.9321944",
      "poi_longitude": "-104.8155446",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 719-385-2489",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-bfc5-734c-889b-a24ab9c4b756.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d27-bfc5-734c-889b-a24ab9c4b756",
        "storage_key": "property/6767906449167186/01a10d27-bfc5-734c-889b-a24ab9c4b756.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8OsQmlOE4cRwRL9fsg9Xio",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_ae23ff74-da51-4497-9f3f-dad9082998ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "The Citadel Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "750 Citadel Dr E, Colorado Springs, CO 80909, USA",
      "poi_short_description": "Mall with apparel, cosmetics, jewelry & electronics stores, salons, a food court & play areas.",
      "poi_long_description": "Mall with apparel, cosmetics, jewelry & electronics stores, salons, a food court & play areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-aee4-75ab-b96e-38c76de01775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-aee4-75ab-b96e-38c76de01775",
        "storage_key": "property/6767906449167186/01a10d27-aee4-75ab-b96e-38c76de01775.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://shopthecitadel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11809864765923250893&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-citadel-mall",
      "poi_latitude": "38.8435391",
      "poi_longitude": "-104.7604257",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 719-591-5515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-644e-7422-a41e-e0c92a9b4209",
        "storage_key": "property/6767906449167186/019d0223-644e-7422-a41e-e0c92a9b4209.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV8YVEdpFE4cRzdJB6m4R5aM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_43b7f0d1-b8d1-4111-b85c-78fc3cf3ba72",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "1475 B St, Colorado Springs, CO 80906, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-b072-75dd-a5f3-30139be80175.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-b072-75dd-a5f3-30139be80175",
        "storage_key": "property/6767906449167186/01a10d27-b072-75dd-a5f3-30139be80175.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.7-eleven.com/locations/co/colorado-springs/1475-b-street-21967?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7503705730086072322&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "38.7677041",
      "poi_longitude": "-104.7967339",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 719-576-2615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6458-744b-9c7a-01279578fb2a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6458-744b-9c7a-01279578fb2a",
        "storage_key": "property/6767906449167186/019d0223-6458-744b-9c7a-01279578fb2a.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJb6APjp9DE4cRAvDX7JqEImg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_4056ad0e-fcfb-4460-be84-e013c7232f56",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "UCHealth Memorial Hospital Central",
      "poi_type": "Health and Wellness",
      "poi_address": "1400 E Boulder St, Colorado Springs, CO 80909, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-4001-761b-84ef-74432e904140.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-4001-761b-84ef-74432e904140",
        "storage_key": "property/6767906449167186/019d0223-4001-761b-84ef-74432e904140.webp",
        "width": 1250,
        "height": 781
      },
      "poi_business_url": "https://www.uchealth.org/locations/uchealth-memorial-hospital-central/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13025990946729059480&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uchealth-memorial-hospital-central",
      "poi_latitude": "38.8402345",
      "poi_longitude": "-104.7991331",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 719-365-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6900-7280-b098-17f0c0f0a383.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6900-7280-b098-17f0c0f0a383",
        "storage_key": "property/6767906449167186/019d0223-6900-7280-b098-17f0c0f0a383.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcNT_3JFE4cRmGQ9W8CdxbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_ffb41c20-2a85-43d0-9eba-745515747034",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "CommonSpirit St. Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6001 E Woodmen Rd, Colorado Springs, CO 80923, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-b189-72f8-aad1-c8acc07bf453.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-b189-72f8-aad1-c8acc07bf453",
        "storage_key": "property/6767906449167186/01a10d27-b189-72f8-aad1-c8acc07bf453.webp",
        "width": 800,
        "height": 541
      },
      "poi_business_url": "https://www.mountain.commonspirit.org/location/st-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=563675664560452527&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commonspirit-st-francis-hospital",
      "poi_latitude": "38.9382588",
      "poi_longitude": "-104.7173539",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "5 hours 22 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 719-571-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6900-7280-b098-17f0c0f0a383.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6900-7280-b098-17f0c0f0a383",
        "storage_key": "property/6767906449167186/019d0223-6900-7280-b098-17f0c0f0a383.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJmVwCfxJJE4cRr3OoygeU0gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_23050d61-96ce-42c6-80a8-e844bc3d1f1b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Cheyenne Mountain Space Force Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "101, Norad Rd #1, Colorado Springs, CO 80906, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-51ef-7339-9b8b-77ff5ff5215e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0223-51ef-7339-9b8b-77ff5ff5215e",
        "storage_key": "property/6767906449167186/019d0223-51ef-7339-9b8b-77ff5ff5215e.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "http://www.norad.mil/AboutNORAD/CheyenneMountainAirForceStation.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=308042707871460001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheyenne-mountain-space-force-station",
      "poi_latitude": "38.7441348",
      "poi_longitude": "-104.8459048",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 719-474-1110",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6c2b-75b1-8a27-5820d6c9cf17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6c2b-75b1-8a27-5820d6c9cf17",
        "storage_key": "property/6767906449167186/019d0223-6c2b-75b1-8a27-5820d6c9cf17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdhPzCBDE4cRoepT8jVjRgQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_d14a4aa6-7610-4894-a1a9-d4c8cb3fb458",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Evans Army Community Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1650 Cochrane Cir, Fort Carson, CO 80913, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-b241-701f-a2f2-4e5353e5cfac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-b241-701f-a2f2-4e5353e5cfac",
        "storage_key": "property/6767906449167186/01a10d27-b241-701f-a2f2-4e5353e5cfac.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://evans.tricare.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3809225363753218302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "evans-army-community-hospital",
      "poi_latitude": "38.7189038",
      "poi_longitude": "-104.7981037",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 719-526-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6900-7280-b098-17f0c0f0a383.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6900-7280-b098-17f0c0f0a383",
        "storage_key": "property/6767906449167186/019d0223-6900-7280-b098-17f0c0f0a383.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzeRFWJCE4cR_jDrQ0kW3TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_17c48d79-f4f6-4181-9411-d263be5dda17",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "US Space Command, Space Operations Command",
      "poi_type": "Major Employers & Offices",
      "poi_address": "150 Vandenberg St, Colorado Springs, CO 80914, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-b460-74fc-8c65-3d17291cb40a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-b460-74fc-8c65-3d17291cb40a",
        "storage_key": "property/6767906449167186/01a10d27-b460-74fc-8c65-3d17291cb40a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.spoc.spaceforce.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16955240334751912776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "us-space-command-space-operations-command",
      "poi_latitude": "38.8348679",
      "poi_longitude": "-104.6996279",
      "poi_miles_from_property": "16.2",
      "poi_walking_minutes": "6 hours 7 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6c2b-75b1-8a27-5820d6c9cf17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6c2b-75b1-8a27-5820d6c9cf17",
        "storage_key": "property/6767906449167186/019d0223-6c2b-75b1-8a27-5820d6c9cf17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUVssgQZHE4cRSFNDckAdTes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_cdc1a5cf-e1e8-4cfc-bc51-112447f33241",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Schriever Space Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4186-3708 Enoch Rd, Colorado Springs, CO 80930, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15958673756390935634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schriever-space-force-base",
      "poi_latitude": "38.7977073",
      "poi_longitude": "-104.5131034",
      "poi_miles_from_property": "26.9",
      "poi_walking_minutes": "9 hours 53 mins",
      "poi_biking_minutes": "2 hours 52 mins",
      "poi_driving_minutes": "42 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/019d0223-6c2b-75b1-8a27-5820d6c9cf17.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0223-6c2b-75b1-8a27-5820d6c9cf17",
        "storage_key": "property/6767906449167186/019d0223-6c2b-75b1-8a27-5820d6c9cf17.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ43z-Pv09E4cRUswHkDqZeN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_a0adbeab-2db9-4a1d-b478-fab73ac5cc88",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "custom",
      "poi_name": "Wings, previously Ent Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11550 Ent Pkwy, Colorado Springs, CO 80921, USA",
      "poi_short_description": "Colorado-based credit union offering financial solutions including savings, checking, and loan services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-b340-7658-9554-9282840e45fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a10d27-b340-7658-9554-9282840e45fa",
        "storage_key": "property/6767906449167186/01a10d27-b340-7658-9554-9282840e45fa.webp",
        "width": 1148,
        "height": 646
      },
      "poi_business_url": "https://www.wingsco.com/?y_source=1_MzMwOTY1NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10518908369044505097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wings-previously-ent-headquarters",
      "poi_latitude": "38.9984463",
      "poi_longitude": "-104.8124089",
      "poi_miles_from_property": "15.6",
      "poi_walking_minutes": "6 hours 0 mins",
      "poi_biking_minutes": "1 hour 44 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 719-574-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167186/01a10d27-bfa5-7529-9fcd-37ed3ac4eb0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a10d27-bfa5-7529-9fcd-37ed3ac4eb0c",
        "storage_key": "property/6767906449167186/01a10d27-bfa5-7529-9fcd-37ed3ac4eb0c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJE0VAJ_1GE4cRCQLIGW6r-pE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "finance"
    }
  ],
  "office_hours": [
    {
      "id": "ec_1526bfcd9e7a6558a60ccbbc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_37c0214a26894256d608beb1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_88562ddfb7271c44666d9e20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4c68dd0c5342b83fd90801bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_eff82c5065be4313a99ae4dc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_82f296ce308c567d4c4d239b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "rating": "5",
      "name": "Christopher Torres",
      "text": "My daughter and I moved in in August of last year(2025), and our experience here has been great! The apartment manager Heather is absolutely amazing at her job. Super fast response to any issues we have had. The maintenance staff is just as good. Frank is the man!  We love the environment here and the neighbors are really nice and mostly quiet here. Great apartment so far!",
      "date": "2026-01-11",
      "title": "false"
    },
    {
      "id": "ec_f51a5799658f366de05477f8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "rating": "5",
      "name": "Annette S",
      "text": "My mom has lived at Cheyenne Creek for 15 years. Heather has made such GREAT improvements since she has managed the property. We are so thankful for her and Frank! Thank you both for making such a difference!",
      "date": "2025-11-10",
      "title": "false"
    },
    {
      "id": "ec_b8cd055d623bddfc9989463a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "rating": "5",
      "name": "Heather Corter",
      "text": "Beautiful property with a creek that ao peaceful to relax next too. Heather is very pleasant to deal with and working hard to make sure things run smoothly and keeps the property looking good.",
      "date": "2025-11-07",
      "title": "false"
    },
    {
      "id": "ec_3bbdea3251c1522f19cb9f09",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "rating": "5",
      "name": "Maryjane Yovish",
      "text": "I absolutely love Cheyenne Creek.! Heather, the office manager,  made my move in so smooth and easy.! I even started crying in the office and she made me feel better by making me feel at home and even surprised us with a beautiful welcome home basket inside our new home.! I have never had the experience of receiving such excellent and professional customer service from any apartment I have moved to. She not only made my boyfriend and I feel welcomed but she made my fur babies feel welcomed as well.! She’s the best.!\n\nTo the amazing Maintenance Team member Jason for fixing our door the first day we moved in, I can’t thank you enough.! You had our front door lock fixed and working in a matter of hours.! Our work order was completed very quickly.!\n\nIf you ever decide to move Cheyenne Creek you are making the RIGHT decision.! They are so welcoming and will make you feel right at home.!\n\nThank you Heather and Jason for making our new home so special for us to enjoy.!",
      "date": "2025-02-26",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "pet_policies": [
    {
      "id": "ec_8269423833fc257573ca2280",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "2520226",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 0,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "false"
    },
    {
      "id": "ec_f368d809c5f09e395c00920e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "yardi",
      "external_id": "2520225",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 2,
      "weight_limit": 70,
      "deposit": 300,
      "fee": 0,
      "monthly_rent": 35,
      "description": "Up to 2 pets per home are welcome.",
      "restrictions": "Breed restrictions apply"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-daaa-7694-a5c6-bbc3d5d4e58f",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Cheyenne Creek Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-colorado-springs",
      "search_query": "apartments with in-unit laundry in Colorado Springs",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Colorado Springs",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Cheyenne Creek, located in the charming Broadmoor neighborhood of Colorado Springs.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Cheyenne Creek, where our apartments with in-unit laundry in Colorado Springs offer a lifestyle upgrade. Nestled in the picturesque Broadmoor area, our community provides the perfect backdrop for exploring El Paso County while relishing in modern comforts at home.\n\nCheyenne Creek doesn't just offer convenience, it offers quality living. Whether you're using the warming drawer in your kitchen or enjoying the spaciousness of our walk-in closets, every feature caters to your needs. With 24-hour access, a lounge for relaxing, and a picnic area for sunny days, every detail at Cheyenne Creek is designed to enhance your living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Colorado Springs",
      "seo_description": "Explore Cheyenne Creek's apartments with in-unit laundry in Colorado Springs' Broadmoor neighborhood. Enjoy convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "generator",
      "page_item_url": "luxury-apartments-air-conditioning-broadmoor",
      "search_query": "luxury apartments with air conditioning in Broadmoor",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Air Conditioning in Broadmoor",
      "h2_subtitle": "Discover luxury living at Cheyenne Creek, featuring apartments with air conditioning in the desirable Broadmoor neighborhood.",
      "page_copy": "Experience upscale comfort at Cheyenne Creek, where luxury apartments with air conditioning in Broadmoor redefine modern living. Nestled in Colorado Springs' prestigious neighborhood, our residences offer a sanctuary from the bustling city, ensuring you enjoy a refreshing escape with central air conditioning in every apartment.\n\nOur community is designed with premium amenities, including a sophisticated lounge, perfect for entertaining guests. Enjoy spacious living with warming drawers and walk-in closets enhancing your day-to-day life. With 24-hour access and a serene picnic area, Cheyenne Creek provides the optimal balance of elegance and convenience in Broadmoor.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with A/C in Broadmoor",
      "seo_description": "Cheyenne Creek offers luxury apartments with air conditioning in Broadmoor, Colorado Springs. Enjoy comfort and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "generator",
      "page_item_url": "cheyenne-creek-apartments-with-dishwasher",
      "search_query": "Cheyenne Creek apartments with dishwasher",
      "category": "Amenity",
      "h1_title": "Cheyenne Creek Apartments with Dishwasher",
      "h2_subtitle": "Enjoy the ease of living at Cheyenne Creek, where each apartment features a dishwasher for your convenience.",
      "page_copy": "At Cheyenne Creek, convenience meets style with apartments that include a dishwasher in every unit. Located in the scenic Broadmoor neighborhood of Colorado Springs, our community provides more than just a place to live – it's a place to enjoy modern conveniences and thoughtful amenities.\n\nBeyond the ease of having a dishwasher, residents enjoy walk-in closets, warming drawers, and access to a cozy lounge area. With 24-hour access and a delightful picnic area, Cheyenne Creek is designed for those who appreciate the finer things in life, including a streamlined kitchen experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cheyenne Creek Apartments with Dishwasher",
      "seo_description": "Find apartments with a dishwasher at Cheyenne Creek in the Broadmoor neighborhood, offering modern amenities and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "generator",
      "page_item_url": "apartment-community-with-pool-el-paso-county",
      "search_query": "apartment community with pool El Paso County",
      "category": "Amenity",
      "h1_title": "Apartment Community with Pool in El Paso County",
      "h2_subtitle": "Explore Cheyenne Creek, an exceptional apartment community with a refreshing pool, located in the heart of El Paso County.",
      "page_copy": "Dive into a lifestyle of leisure at Cheyenne Creek, an apartment community ideally situated in El Paso County. While we pride ourselves on excellent amenities, such as spacious walk-in closets and a modern warming drawer, our community is also home to a refreshing pool, perfect for relaxation and recreation.\n\nPositioned in the beautiful Broadmoor neighborhood of Colorado Springs, Cheyenne Creek offers more than just a home. Enjoy time in the cozy lounge or take advantage of the picnic area, all designed with your comfort in mind. With 24-hour access to our amenities, living at Cheyenne Creek means enjoying a balanced blend of relaxation and convenience right in El Paso County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Community with Pool in El Paso County",
      "seo_description": "Experience Cheyenne Creek's apartment community with a pool, offering modern amenities in El Paso County's Broadmoor neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-near-colorado-springs-80906",
      "search_query": "pet-friendly apartments near Colorado Springs 80906",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments Near Colorado Springs 80906",
      "h2_subtitle": "Welcome to Cheyenne Creek, offering pet-friendly apartments in the heart of Colorado Springs' 80906 area.",
      "page_copy": "Discover a welcoming home for you and your furry friends at Cheyenne Creek, where pet-friendly apartments are perfectly located near Colorado Springs and within the 80906 ZIP code. Our community embraces a harmonious lifestyle for pet owners, providing a pleasant living environment both you and your pets will love.\n\nLocated in the charming Broadmoor neighborhood, Cheyenne Creek combines comfortable living with modern amenities, including spacious walk-in closets and a relaxing picnic area. Enjoy the convenience of 24-hour access and a cozy lounge, all while your pets feel right at home in our accommodating setting. Explore the natural beauty of the surrounding El Paso County with your pet by your side.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments Near Colorado Springs 80906",
      "seo_description": "Find pet-friendly apartments at Cheyenne Creek, located near Colorado Springs in the 80906 area, offering a welcoming community for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167186",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-broadmoor-colorado-springs",
      "search_query": "two bedroom apartments broadmoor colorado springs",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Broadmoor, Colorado Springs",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Cheyenne Creek, located in the beautiful Broadmoor area of Colorado Springs.",
      "page_copy": "Finding the perfect home is easy at Cheyenne Creek, where we offer two-bedroom apartments nestled in the desirable Broadmoor neighborhood of Colorado Springs. Our spacious layouts are thoughtfully designed to cater to your lifestyle needs, providing ample room and modern amenities.\n\nCheyenne Creek is not just about shelter; it's about lifestyle. Enjoy walk-in closets, a convenient warming drawer, and the luxury of a lounge and picnic area. Our apartments offer 24-hour access, so you can enjoy all these features at any time. Experience the blend of comfort and style in our vibrant community, where your two-bedroom apartment awaits amidst the lush landscapes of Colorado Springs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Broadmoor, CO Springs",
      "seo_description": "Discover two-bedroom apartments at Cheyenne Creek in Broadmoor, Colorado Springs. Enjoy spacious living and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309480411"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7194263536"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TGWH4NJK"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "be9fc3ee-3b1f-4f70-a6c7-f07dfc53fc6b"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/63fba167-733e-4da0-8b55-fb85891651af/app.js?property=63fba167-733e-4da0-8b55-fb85891651af&propertyName=Cheyenne+Creek&channelUuid=c248e952-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47593918060"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InVYb2lQWEphQXpxNC9iUEFxVkpWK3c9PSIsInZhbHVlIjoiQWtYVzl2UlNzMDdndEdmOE9EN09vZz09IiwibWFjIjoiNDc5NjcxNmMyYmEyMmVkN2VmMzgyMDg0NDgxODI5OTM1ZjkxOTAxMTY1NDIwZjYwNjAyMWRkNjdmOGMyOGM1NSJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309480411",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=7194263536",
  "custom_google_gtm_id": "GTM-TGWH4NJK",
  "custom_rollout_phase": "Phase 8",
  "custom_rentgrata_token": "be9fc3ee-3b1f-4f70-a6c7-f07dfc53fc6b",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/63fba167-733e-4da0-8b55-fb85891651af/app.js?property=63fba167-733e-4da0-8b55-fb85891651af&propertyName=Cheyenne+Creek&channelUuid=c248e952-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47593918060",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InVYb2lQWEphQXpxNC9iUEFxVkpWK3c9PSIsInZhbHVlIjoiQWtYVzl2UlNzMDdndEdmOE9EN09vZz09IiwibWFjIjoiNDc5NjcxNmMyYmEyMmVkN2VmMzgyMDg0NDgxODI5OTM1ZjkxOTAxMTY1NDIwZjYwNjAyMWRkNjdmOGMyOGM1NSJ9",
  "custom_audioeye_site_id": "a8a41066-dcb1-4beb-8db3-7b7cd5de72ff",
  "custom_audioeye_site_hash": "27b3128fb551ae28ce85006afe4333fb"
};

export const generatedAt = '2026-11-04T23:48:14.301Z';
